/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export interface APIWaitlist {
  /**
   * @format email
   * @maxLength 254
   */
  email: string;
  name: string;
  company?: string;
  role?: string;
  phone?: string;
}

export interface Action {
  id: number;
  /** @maxLength 255 */
  name: string;
  description: string;
  /** @format date-time */
  created_at: string;
  /** @format date-time */
  updated_at: string;
  public?: boolean;
  /** @maxLength 200 */
  instruction: string;
  execution_type?: any;
  /**
   * @format uri
   * @maxLength 500
   */
  image_url?: string | null;
  default?: boolean;
}

export interface ActionResult {
  title: string;
  description: string;
  url: string;
  /** @format uri */
  image_url?: string;
}

/**
 * * `text` - Text
 * * `number` - Number
 * * `email` - Email
 * * `date` - Date
 * * `phone` - Phone
 */
export enum AllowedFormatEnum {
  Text = "text",
  Number = "number",
  Email = "email",
  Date = "date",
  Phone = "phone",
}

/**
 * * `DistributionAnalysis` - Distribution Analysis
 * * `CorrelationAnalysis` - Correlation Analysis
 * * `SearchAnalysis` - Search Analysis
 */
export enum AnalysisClassEnum {
  DistributionAnalysis = "DistributionAnalysis",
  CorrelationAnalysis = "CorrelationAnalysis",
  SearchAnalysis = "SearchAnalysis",
}

export interface AuthorizationCode {
  code: string;
}

export interface BatchSearchResult {
  results: QuerySearchResult[];
}

export interface BenchmarkDataset {
  query_dataset_id: number;
  answer_dataset_id: number;
  /** @format double */
  oasis_ranked_below_score: number;
  /** @format double */
  semantic_ranked_below_score: number;
}

export interface BenchmarkDatasetArgs {
  query_dataset_id: number;
  answer_dataset_id: number;
}

export interface BenchmarkSummaryResponse {
  entity_collection_id: string;
  dimensions: string[];
  queries_used: string[];
  /** Dict with k values as keys (strings), each containing {mean, median, stdev, count} */
  semantic_stats: Record<string, any>;
  /** Dict with k values as keys (strings), each containing {mean, median, stdev, count} */
  oasis_stats: Record<string, any>;
  /** Dict with k values as keys (strings), each containing {semantic_better, oasis_better, ties, compared_count} */
  comparisons: Record<string, any>;
  /** Dict containing semantic_scores and oasis_scores, each with k values as keys */
  metadata: Record<string, any>;
}

/**
 * * `TEXT` - Text
 * * `ANALYSIS` - Analysis
 * * `BENCHMARK` - Benchmark
 */
export enum BlockTypeEnum {
  TEXT = "TEXT",
  ANALYSIS = "ANALYSIS",
  BENCHMARK = "BENCHMARK",
}

export interface CancelLLMJob {
  id: number;
}

export interface ChatMessage {
  role: string;
  content: string;
  tool_call_id?: string;
  name?: string;
  tool_calls?: any[];
}

export interface ChatRequest {
  message: string;
  conversation_id?: number;
  model?: string;
  stream?: boolean;
}

export interface ChatResponse {
  messages: ChatMessage[];
}

export interface ContactUsResponse {
  /**
   * @format email
   * @maxLength 254
   */
  email: string;
  message: string;
  name: string;
  company: string;
  role: string;
}

export interface Conversation {
  id: number;
  /** @maxLength 255 */
  title: string;
  /** @maxLength 50 */
  model_name: string;
  /** @format date-time */
  created_at: string;
  /** @format date-time */
  updated_at: string;
  messages: Message[];
  /** @maxLength 255 */
  agent_slug?: string | null;
  agent_params?: any;
}

export interface CopilotSuggestion {
  context: Record<string, any>;
  input: Record<string, any>;
}

export interface CreateActionError {
  error: string;
}

export interface CreateAndUpdateDatabase {
  /** @maxLength 255 */
  name: string;
  description: string;
  is_public?: boolean;
}

export interface CreateEntitiesRequest {
  entity_collection_metadata: EntityMetadataResponse;
  entities: Record<string, Record<string, number>>[];
}

export interface CreateExperimentFromTemplateOptional {
  search_results_dataset_id?: number;
  benchmark_dataset_id?: number;
}

export interface CreateExperimentFromTemplateResponse {
  optional: CreateExperimentFromTemplateOptional;
}

export interface CreateExternalOAuthTokenRequest {
  app_slug: string;
}

export interface CreateExternalOAuthTokenResponse {
  access_token: string;
  secret_token: string;
}

export interface CreateVectorOntologyRequest {
  vector_ontology: string[];
  dataset_id: number;
  use_keys?: string[];
  name: string;
  description: string;
}

export interface DataProcessingRequest {
  dataset: string;
  ranking_algorithm: string;
  operation: string;
  dimensions?: Record<string, any>;
  query?: string;
}

export interface DataProcessingResponse {
  computedAxis: string;
  dataPoints: Record<string, any>[];
  dimensions: string[];
  database: string;
}

export interface DataSetConfigurationResponse {
  DATA_SETS: Record<string, Record<string, any>>;
  OPERATIONS: Record<string, Record<string, any>>;
}

export interface DatabaseList {
  databases: Record<string, any>[];
}

export interface Dataset {
  id: number;
  data_count: string;
  parent_dataset: string;
  is_root: string;
  sample_datum: Datum;
  /** @maxLength 255 */
  name: string;
  /** @maxLength 255 */
  data_type: string;
  /** @maxLength 255 */
  data_source: string;
  description: string;
  /** @format date-time */
  created_at: string;
  meta_data?: any;
  account?: number | null;
  subsets: number[];
}

export interface DatasetUpdate {
  /** @maxLength 255 */
  name: string;
  description: string;
  /** @maxLength 255 */
  data_type: string;
  /** @maxLength 255 */
  data_source: string;
  meta_data?: any;
}

export interface Datum {
  id: number;
  content: any;
  meta_data?: any;
  dataset: number;
  llm_job?: number | null;
}

/**
 * * `single` - Single Deadline
 * * `multiple_cut_off` - Multiple Cut-Off
 * * `two_stage` - Two-Stage
 */
export enum DeadlineModelEnum {
  Single = "single",
  MultipleCutOff = "multiple_cut_off",
  TwoStage = "two_stage",
}

export interface DetailedDocument {
  /** @format uuid */
  id: string;
  /** @maxLength 255 */
  name: string;
  /** @format date-time */
  created_at: string;
  /** @format date-time */
  updated_at: string;
  raw_document_presigned_url: string;
  text_document_presigned_url: string;
  /**
   * * `pending` - Pending
   * * `document_parsing` - Document Parsing
   * * `document_parsed` - Document Parsed
   * * `document_parsing_failed` - Document Parsing Failed
   */
  parsing_status?: ParsingStatusEnum;
  /**
   * * `pending` - Pending
   * * `entity_indexing` - Entity Indexing
   * * `entity_indexed` - Entity Indexed
   * * `entity_indexing_failed` - Entity Indexing Failed
   */
  entity_indexing_status?: EntityIndexingStatusEnum;
  summary?: string | null;
}

export interface Dimension {
  /** @format uuid */
  id: string;
  /** @maxLength 255 */
  name: string;
  description: string;
  live: boolean;
  indexed?: boolean;
  /**
   * * `synthetic` - Synthetic
   * * `form` - Form
   */
  type?: DimensionTypeEnum;
  dimension_type: string;
  synthetic_configuration: SyntheticDimensionConfiguration;
}

export interface DimensionAnalyticsResponse {
  dimensions: Record<string, any>[];
  entity_distributions: Record<string, any>;
  query_distributions: Record<string, any>;
  entity_correlation_matrix: Record<string, any>;
  query_correlation_matrix: Record<string, any>;
  type_analysis: Record<string, any>;
  dimension_scores: Record<string, any>;
  weight_analytics: Record<string, any>;
  /** @format double */
  score_weight_correlation: number | null;
  /** @format double */
  score_weight_correlation_pvalue: number | null;
  score_weight_correlation_n: number;
  /** Shannon entropy H(X) in bits for each dimension (entity data). Higher = more spread/discriminative. */
  entity_entropy: Record<string, number | null>;
  /** Shannon entropy H(X) in bits for each dimension (query data). */
  query_entropy: Record<string, number | null>;
  /** Pairwise mutual information I(X;Y) matrix (entity data). Lower = more orthogonal/independent. Diagonal = entropy. */
  entity_mutual_information_matrix: Record<string, any>;
  /** Pairwise mutual information I(X;Y) matrix (query data). */
  query_mutual_information_matrix: Record<string, any>;
  /** Conditional entropy H(X|Y) matrix (entity data). High = X is independent of Y. */
  entity_conditional_entropy_matrix: Record<string, any>;
  /** Conditional entropy H(X|Y) matrix (query data). */
  query_conditional_entropy_matrix: Record<string, any>;
}

export interface DimensionCollection {
  id: number;
  dimensions: Dimension[];
  live?: boolean;
  indexable_dimensions: string[];
  live_history: DimensionCollectionLiveHistory[];
  /** @format date-time */
  created_at: string;
}

export interface DimensionCollectionLiveHistory {
  id: number;
  /** @format date-time */
  went_live_at: string;
  /** @format date-time */
  went_offline_at?: string | null;
}

export interface DimensionLeaderboardEntry {
  id: number;
  user_name: string;
  dimension: Dimension;
  /** @format date-time */
  created_at: string;
  /** @format double */
  rank_reward: number;
  /**
   * @min -2147483648
   * @max 2147483647
   */
  num_entities: number;
  /**
   * @min -2147483648
   * @max 2147483647
   */
  num_queries: number;
  distribution?: any;
  /** @format double */
  information: number;
  account?: number | null;
  dataset?: number | null;
}

/**
 * * `synthetic` - Synthetic
 * * `form` - Form
 */
export enum DimensionTypeEnum {
  Synthetic = "synthetic",
  Form = "form",
}

export interface Document {
  /** @format uuid */
  id: string;
  /** @maxLength 255 */
  name: string;
  /** @maxLength 255 */
  file_type: string;
  /** @format date-time */
  created_at: string;
  /** @format date-time */
  updated_at: string;
  /**
   * * `pending` - Pending
   * * `document_parsing` - Document Parsing
   * * `document_parsed` - Document Parsed
   * * `document_parsing_failed` - Document Parsing Failed
   */
  parsing_status?: ParsingStatusEnum;
  /**
   * * `pending` - Pending
   * * `entity_indexing` - Entity Indexing
   * * `entity_indexed` - Entity Indexed
   * * `entity_indexing_failed` - Entity Indexing Failed
   */
  entity_indexing_status?: EntityIndexingStatusEnum;
  summary?: string | null;
}

export interface DomainResult {
  title: string;
  description: string;
  url: string;
  image_urls?: string[];
  domain: string;
  type: string;
}

export interface DomainSearchRequest {
  q: string;
  domain: string;
}

export interface EUFunctionDimensionRequest {
  params: Record<string, any>;
  query: string;
  wished_for_dimensions: Record<string, any>;
  dimensions_score: number;
  semantic_score: number;
  conversation_summary: string;
}

export interface EUFunctionDimensionResponse {
  response: Record<string, any>;
}

export interface EUFundingSource {
  id: number;
  /** @maxLength 255 */
  external_id: string;
  /** @maxLength 255 */
  title?: string | null;
  summary?: string | null;
  content?: string | null;
  /**
   * @format uri
   * @maxLength 1024
   */
  url: string;
  /** @maxLength 255 */
  identifier?: string | null;
  /** @maxLength 255 */
  topic_title?: string | null;
  /** @maxLength 255 */
  call_title?: string | null;
  description?: string | null;
  conditions?: string | null;
  /**
   * * `single` - Single Deadline
   * * `multiple_cut_off` - Multiple Cut-Off
   * * `two_stage` - Two-Stage
   */
  deadline_model: DeadlineModelEnum;
  /**
   * @format decimal
   * @pattern ^-?\d{0,12}(?:\.\d{0,2})?$
   */
  min_grant?: string | null;
  /**
   * @format decimal
   * @pattern ^-?\d{0,12}(?:\.\d{0,2})?$
   */
  max_grant?: string | null;
  /**
   * @min -2147483648
   * @max 2147483647
   */
  number_of_grants?: number | null;
  deadlines?: string[];
  extra_information?: any;
  geographies?: any;
  /** @format date-time */
  latest_deadline?: string | null;
  ai_summary?: string | null;
  /** @format date-time */
  earliest_deadline?: string | null;
  ai_short_description?: string | null;
  /** @maxLength 255 */
  ai_max_funding_amount?: string | null;
  /** @maxLength 50 */
  ai_funding_amount_currency?: string | null;
  ai_locations?: any;
  /** @format double */
  sustainability?: number;
  /** @format double */
  innovation?: number;
  /** @format double */
  economic_scalability_and_impact?: number;
  /** @format double */
  interdisciplinary_collaboration?: number;
  /** @format double */
  technological_readiness?: number;
  /** @format double */
  impact?: number;
  /** @format double */
  feasibility_and_support?: number;
  /** @format double */
  collaboration?: number;
  /** @format double */
  support_and_training?: number;
  /** @format double */
  strategic_alignment?: number;
  /** @format double */
  financial_suitability?: number;
  /** @format double */
  efficiency_and_quality?: number;
  /** @format double */
  compliance_and_administration?: number;
  /** @format double */
  evaluation_and_feedback?: number;
  /** @format double */
  clarity_and_requirements?: number;
  /** @format double */
  financial_considerations_and_support?: number;
  /** @format double */
  digital_transformation_and_innovation?: number;
  /** @format double */
  sustainability_focus_and_innovation?: number;
  /** @format double */
  accountability?: number;
  /** @format double */
  relevance_to_environmental_studies?: number;
  /** @format double */
  focus_on_marine_pollution?: number;
  /** @format double */
  response_to_accidental_releases?: number;
  /** @format double */
  support_for_alternative_fuels?: number;
  /** @format double */
  rigorous_criteria_for_funding?: number;
  /** @format double */
  financials?: number;
  /** @format double */
  management?: number;
  /** @format double */
  eligibility?: number;
  /** @format double */
  objectives?: number;
  /** @format double */
  support?: number;
  /** @format double */
  alignment_with_goals?: number;
  /** @format double */
  geographical_focus?: number;
  /** @format double */
  relevance_to_sector?: number;
  /** @format double */
  financial_details?: number;
  /** @format double */
  deadlines_and_timing?: number;
  /** @format double */
  transparency?: number;
  /** @format double */
  resource_availability?: number;
  /** @format double */
  environmental_impact?: number;
  /** @format double */
  potential_impact?: number;
  /** @format double */
  reliability?: number;
  /** @format double */
  commitment?: number;
  /** @format double */
  organizational_capacity?: number;
  /** @format double */
  quality_of_measures?: number;
  /** @format double */
  monitoring_and_compliance?: number;
  /** @format double */
  non_discrimination_and_inclusivity?: number;
  /** @format double */
  ethical_volunteering_practices?: number;
  /** @format double */
  impact_orientation?: number;
  /** @format double */
  workforce_development?: number;
  /** @format double */
  competitive?: number;
  /** @format double */
  urban_partnership?: number;
  /** @format double */
  knowledge_sharing?: number;
  /** @format double */
  funder_clarity_and_transparency?: number;
  /** @format double */
  financial_support_details?: number;
}

export interface EditActionError {
  error: string;
}

export interface EditActionNotFound {
  error: string;
}

export interface Entity {
  /** @format uuid */
  id: string;
  content: any;
  embedding: EntityEmbedding;
  distance: string;
  /** @format uuid */
  document?: string | null;
}

export interface EntityCollection {
  /** @format uuid */
  id: string;
  /** @maxLength 255 */
  name: string;
  entities: Entity[];
  semantic_index_keys?: any;
  oasis_index_keys?: any;
  oasis_form_data_index_keys?: any;
  ui_mapping?: any;
  simple_keys?: any;
  all_keys?: any;
  entity_type: string;
  entity_description: string;
  entity_count: number;
}

export interface EntityEmbedding {
  id: number;
  embedding: string;
  metadata?: any;
  live?: boolean;
}

/**
 * * `pending` - Pending
 * * `entity_indexing` - Entity Indexing
 * * `entity_indexed` - Entity Indexed
 * * `entity_indexing_failed` - Entity Indexing Failed
 */
export enum EntityIndexingStatusEnum {
  Pending = "pending",
  EntityIndexing = "entity_indexing",
  EntityIndexed = "entity_indexed",
  EntityIndexingFailed = "entity_indexing_failed",
}

export interface EntityMetadataResponse {
  semantic_index_keys: string[];
  oasis_index_keys: string[];
  oasis_form_data_index_keys: string[];
  ui_mapping: Record<string, string>;
  simple_keys: string[];
  all_keys: string[];
  entity_type: string;
  entity_description: string;
}

export interface EntityNeighboursResponse {
  /** Dict mapping entity_id to {entity_id, content, distance} of closest neighbour */
  neighbours: Record<string, any>;
  /** Dict mapping entity_id to entity content */
  entity_contents: Record<string, any>;
  /** List of {entity_id, content, distance_to_closest} sorted by distance (furthest from closest neighbour first) */
  most_isolated: Record<string, any>[];
}

export interface EntropyRankCorrelationResponse {
  /** List of sampled entities with their isolation score (distance to nearest neighbor) and search rank */
  samples: Record<string, any>[];
  /**
   * Spearman correlation coefficient. Negative = isolated entities rank better.
   * @format double
   */
  correlation: number | null;
  /**
   * Statistical significance of the correlation
   * @format double
   */
  pvalue: number | null;
  /** Number of valid samples used in correlation */
  n_samples: number;
  /** Total entities sampled */
  n_total_sampled: number;
  /** Entities with associated queries */
  n_with_queries: number;
  /** Isolation bin boundaries */
  bin_percentiles: number[];
  /** Details about each bin */
  bin_info: Record<string, any>[];
  /** Human-readable interpretation of results */
  interpretation: string;
  /** The metric used: isolation_distance */
  metric: string;
  /** The distance metric used */
  distance_metric: string;
  /** Summary statistics */
  summary_stats: Record<string, any>;
}

export interface ErrorResponse {
  error: string;
}

export interface Experiment {
  id: number;
  operations: Operation[];
  input_datasets: string;
  output_dataset: string;
  /**
   * * `LLMExperiment` - LLM Experiment
   * * `SearchExperiment` - Search Experiment
   */
  experiment_class: ExperimentClassEnum;
  /** @maxLength 255 */
  name: string;
  description: string;
  /** @format date */
  created_at: string;
  /**
   * * `PENDING` - PENDING
   * * `RUNNING` - RUNNING
   * * `COMPLETED` - COMPLETED
   * * `FAILED` - FAILED
   */
  status?: ExperimentStatus;
  account?: number | null;
}

/**
 * * `LLMExperiment` - LLM Experiment
 * * `SearchExperiment` - Search Experiment
 */
export enum ExperimentClassEnum {
  LLMExperiment = "LLMExperiment",
  SearchExperiment = "SearchExperiment",
}

export interface ExperimentOverview {
  id: number;
  /** @maxLength 255 */
  name: string;
  description: string;
  /** @format date */
  created_at: string;
  /**
   * * `PENDING` - PENDING
   * * `RUNNING` - RUNNING
   * * `COMPLETED` - COMPLETED
   * * `FAILED` - FAILED
   */
  status?: ExperimentStatus;
}

/**
 * * `PENDING` - PENDING
 * * `RUNNING` - RUNNING
 * * `COMPLETED` - COMPLETED
 * * `FAILED` - FAILED
 */
export enum ExperimentStatus {
  PENDING = "PENDING",
  RUNNING = "RUNNING",
  COMPLETED = "COMPLETED",
  FAILED = "FAILED",
}

export interface ExportDataset {
  id: number;
  data: Datum[];
  data_csv: string;
  /** @maxLength 255 */
  name: string;
  /** @maxLength 255 */
  data_type: string;
  /** @maxLength 255 */
  data_source: string;
  description: string;
  /** @format date-time */
  created_at: string;
  meta_data?: any;
  account?: number | null;
  subsets: number[];
}

export interface ExportExperiment {
  id: number;
  operations: ExportOperation[];
  status: string;
  /**
   * * `LLMExperiment` - LLM Experiment
   * * `SearchExperiment` - Search Experiment
   */
  experiment_class: ExperimentClassEnum;
  /** @maxLength 255 */
  name: string;
  description: string;
  /** @format date */
  created_at: string;
  account?: number | null;
}

export interface ExportOperation {
  id: number;
  input_dataset?: Dataset;
  output_dataset?: Dataset;
  system_prompt_template?: FullPromptTemplate;
  user_prompt_template?: FullPromptTemplate;
  /**
   * * `PENDING` - PENDING
   * * `RUNNING` - RUNNING
   * * `COMPLETED` - COMPLETED
   * * `BATCH_PROCESSING` - BATCH_PROCESSING
   * * `FAILED` - FAILED
   * * `CANCELLED` - CANCELLED
   */
  status?: PossibleProcessingStatus;
  /** @maxLength 255 */
  execution_class: string;
  description: string;
  name: string;
  /** @format date-time */
  created_at: string;
  /** @format date-time */
  started_at?: string | null;
  /** @format date-time */
  finished_at?: string | null;
  /**
   * @min -2147483648
   * @max 2147483647
   */
  experiment_order?: number;
  model?: ModelEnum | NullEnum | null;
  can_run?: boolean;
  params?: any;
  experiment?: number | null;
  account?: number | null;
}

export interface Form {
  /** @format uuid */
  id: string;
  fields: FormField[];
  submissions: string;
  submissionCount: string;
  /** @maxLength 255 */
  title: string;
  purpose?: string;
  /** @format date-time */
  created_at: string;
  account: number;
}

export interface FormField {
  /** @format uuid */
  id: string;
  /** @maxLength 255 */
  name: string;
  description?: string;
  mandatory?: boolean;
  /**
   * * `text` - Text
   * * `number` - Number
   * * `email` - Email
   * * `date` - Date
   * * `phone` - Phone
   */
  allowed_format?: AllowedFormatEnum;
  disabled?: boolean;
  /** @format date-time */
  created_at: string;
  /** @format uuid */
  form: string;
}

export interface FullAnalysis {
  id: number;
  input_datasets?: Dataset[];
  config: any;
  search_collection: SearchCollection;
  /** @maxLength 255 */
  name: string;
  description: string;
  /**
   * * `DistributionAnalysis` - Distribution Analysis
   * * `CorrelationAnalysis` - Correlation Analysis
   * * `SearchAnalysis` - Search Analysis
   */
  analysis_class: AnalysisClassEnum;
  params?: any;
  outputs?: any;
  /** @format date-time */
  created_at: string;
  /** @format date-time */
  updated_at: string;
  account?: number | null;
  study?: number | null;
}

export interface FullExperiment {
  id: number;
  operations: FullOperation[];
  input_datasets: Dataset[];
  output_dataset: string;
  /**
   * * `LLMExperiment` - LLM Experiment
   * * `SearchExperiment` - Search Experiment
   */
  experiment_class: ExperimentClassEnum;
  /** @maxLength 255 */
  name: string;
  description: string;
  /** @format date */
  created_at: string;
  /**
   * * `PENDING` - PENDING
   * * `RUNNING` - RUNNING
   * * `COMPLETED` - COMPLETED
   * * `FAILED` - FAILED
   */
  status?: ExperimentStatus;
  account?: number | null;
}

export interface FullOperation {
  id: number;
  input_dataset?: Dataset;
  output_dataset?: Dataset;
  system_prompt_template?: FullPromptTemplate;
  user_prompt_template?: FullPromptTemplate;
  allowed_params: any;
  mandatory_params: any;
  /** @format double */
  minimum_cost: number | null;
  llm_jobs: string;
  num_llm_jobs: any;
  /**
   * * `PENDING` - PENDING
   * * `RUNNING` - RUNNING
   * * `COMPLETED` - COMPLETED
   * * `BATCH_PROCESSING` - BATCH_PROCESSING
   * * `FAILED` - FAILED
   * * `CANCELLED` - CANCELLED
   */
  status?: PossibleProcessingStatus;
  /** @maxLength 255 */
  execution_class: string;
  description: string;
  name: string;
  /** @format date-time */
  created_at: string;
  /** @format date-time */
  started_at?: string | null;
  /** @format date-time */
  finished_at?: string | null;
  /**
   * @min -2147483648
   * @max 2147483647
   */
  experiment_order?: number;
  model?: ModelEnum | NullEnum | null;
  can_run?: boolean;
  params?: any;
  experiment?: number | null;
  account?: number | null;
}

export interface FullPromptTemplate {
  id: number;
  dataset?: Dataset;
  /** @maxLength 255 */
  name: string;
  description: string;
  prompt?: string;
  /** @format date-time */
  created_at: string;
  /** @format date-time */
  updated_at: string;
  type?: Type283Enum | NullEnum | null;
  /**
   * * `JSON` - JSON
   * * `STRING` - STRING
   */
  output_type?: OutputTypeEnum;
  account?: number | null;
}

export interface FullStudy {
  id: number;
  blocks: FullStudyBlock[];
  /** @maxLength 255 */
  name: string;
  description: string;
  /** @format date-time */
  created_at: string;
  /** @format date-time */
  updated_at: string;
  account?: number | null;
  experiments: number[];
}

export interface FullStudyBlock {
  id: number;
  analysis?: FullAnalysis;
  experiment?: FullExperiment;
  /**
   * * `TEXT` - Text
   * * `ANALYSIS` - Analysis
   * * `BENCHMARK` - Benchmark
   */
  block_type: BlockTypeEnum;
  /**
   * @min 0
   * @max 2147483647
   */
  order: number;
  content?: string | null;
  study: number;
  account?: number | null;
}

export interface GetDimensionLeaderboardRequest {
  dimension_id: number;
}

export interface GetLeaderboardRequest {
  dataset_id?: number;
}

export interface IndexRequestsResponse {
  semantic_index_requests: SemanticIndexRequest[];
  oasis_index_requests: OasisIndexRequest[];
}

export interface LLMFunctionCallerRequest {
  function_name: string;
  arguments: Record<string, any>;
}

export interface LLMFunctionCallerResponse {
  response: Record<string, any>;
}

export interface LLMJob {
  id: number;
  datum: Datum;
  messages: any;
  /**
   * * `PENDING` - PENDING
   * * `RUNNING` - RUNNING
   * * `COMPLETED` - COMPLETED
   * * `BATCH_PROCESSING` - BATCH_PROCESSING
   * * `FAILED` - FAILED
   * * `CANCELLED` - CANCELLED
   */
  status?: PossibleProcessingStatus;
  /** @format date-time */
  created_at: string;
  error_message: string;
  pass_through_data?: any;
  parameters?: any;
  operation: number;
  account?: number | null;
}

export interface Login {
  email: string;
  password: string;
}

/**
 * * `perfect_match` - perfect_match
 * * `good_match` - good_match
 * * `match` - match
 * * `partial_match` - partial_match
 * * `irrelevant` - irrelevant
 * * `contradiction` - contradiction
 */
export enum MatchTypeEnum {
  PerfectMatch = "perfect_match",
  GoodMatch = "good_match",
  Match = "match",
  PartialMatch = "partial_match",
  Irrelevant = "irrelevant",
  Contradiction = "contradiction",
}

export interface Message {
  id: number;
  /** @maxLength 20 */
  role: string;
  content?: string | null;
  /** @format date-time */
  created_at: string;
}

/**
 * * `gpt-4o` - GPT-4o
 * * `gpt-4o-mini` - GPT-4o-mini
 * * `openai/o1-preview` - openai/o1-preview
 * * `openai/o1-mini` - openai/o1-mini
 * * `qwen/qwq-32b-preview` - qwen/qwq-32b-preview
 * * `qwen/qvq-72b-preview` - qwen/qvq-72b-preview
 * * `gpt-4o-mini-batch` - GPT-4o-mini-batch
 * * `gpt-4o-batch` - GPT-4o-batch
 * * `meta-llama/llama-3.1-405b-instruct:free` - meta-llama/llama-3.1-405b-instruct:free
 * * `ollama/phi:chat` - ollama/phi:chat
 * * `ollama/llama3.2` - ollama/llama3.2
 * * `ollama/llama3` - ollama/llama3
 * * `anthropic/claude-3.5-sonnet` - anthropic/claude-3.5-sonnet
 */
export enum ModelEnum {
  Gpt4O = "gpt-4o",
  Gpt4OMini = "gpt-4o-mini",
  OpenaiO1Preview = "openai/o1-preview",
  OpenaiO1Mini = "openai/o1-mini",
  QwenQwq32BPreview = "qwen/qwq-32b-preview",
  QwenQvq72BPreview = "qwen/qvq-72b-preview",
  Gpt4OMiniBatch = "gpt-4o-mini-batch",
  Gpt4OBatch = "gpt-4o-batch",
  MetaLlamaLlama31405BInstructFree = "meta-llama/llama-3.1-405b-instruct:free",
  OllamaPhiChat = "ollama/phi:chat",
  OllamaLlama32 = "ollama/llama3.2",
  OllamaLlama3 = "ollama/llama3",
  AnthropicClaude35Sonnet = "anthropic/claude-3.5-sonnet",
}

export type NullEnum = null;

export interface OasisIndexRequest {
  id: number;
  /**
   * * `pending` - Pending
   * * `running` - Running
   * * `waiting_for_gpu_tasks` - Waiting For Gpu Tasks
   * * `gpu_tasks_running` - Gpu Tasks Running
   * * `completed` - Completed
   * * `failed` - Failed
   */
  status?: OasisIndexRequestStatusEnum;
  /** @format date-time */
  created_at: string;
  /** @format date-time */
  updated_at: string;
  pipeline_status?: any;
}

export interface OasisIndexRequestMetadataResponse {
  id: number;
  metadata: Record<string, any>;
  status: string;
  pipeline_status: Record<string, any>;
  error_message: string | null;
  pipeline_classes: any[];
  /** @format date-time */
  created_at: string;
  /** @format date-time */
  updated_at: string;
}

/**
 * * `pending` - Pending
 * * `running` - Running
 * * `waiting_for_gpu_tasks` - Waiting For Gpu Tasks
 * * `gpu_tasks_running` - Gpu Tasks Running
 * * `completed` - Completed
 * * `failed` - Failed
 */
export enum OasisIndexRequestStatusEnum {
  Pending = "pending",
  Running = "running",
  WaitingForGpuTasks = "waiting_for_gpu_tasks",
  GpuTasksRunning = "gpu_tasks_running",
  Completed = "completed",
  Failed = "failed",
}

export interface OasisSearchResult {
  results: Entity[];
  oasis_query_embedding: Record<string, any>;
  oasis_weight_embedding: Record<string, any>;
  oasis_ftv_embedding?: Record<string, any>;
}

export interface OntologyLeaderboardEntry {
  id: number;
  user_name: string;
  vector_ontology: VectorOntology;
  /** @format date-time */
  created_at: string;
  /** @format double */
  reconstruction_reward: number;
  /** @format double */
  rank_reward: number;
  /**
   * @min -2147483648
   * @max 2147483647
   */
  num_entities: number;
  /**
   * @min -2147483648
   * @max 2147483647
   */
  num_queries: number;
  /**
   * @min -2147483648
   * @max 2147483647
   */
  seed: number;
  account?: number | null;
  dataset?: number | null;
}

export interface Operation {
  id: number;
  input_dataset?: number | null;
  output_dataset?: number | null;
  system_prompt_template?: number | null;
  user_prompt_template?: number | null;
  llm_jobs: string;
  num_llm_jobs: string;
  /**
   * * `PENDING` - PENDING
   * * `RUNNING` - RUNNING
   * * `COMPLETED` - COMPLETED
   * * `BATCH_PROCESSING` - BATCH_PROCESSING
   * * `FAILED` - FAILED
   * * `CANCELLED` - CANCELLED
   */
  status?: PossibleProcessingStatus;
  /** @maxLength 255 */
  execution_class: string;
  description: string;
  name: string;
  /** @format date-time */
  created_at: string;
  /** @format date-time */
  started_at?: string | null;
  /** @format date-time */
  finished_at?: string | null;
  /**
   * @min -2147483648
   * @max 2147483647
   */
  experiment_order?: number;
  model?: ModelEnum | NullEnum | null;
  can_run?: boolean;
  params?: any;
  experiment?: number | null;
  account?: number | null;
}

/**
 * * `JSON` - JSON
 * * `STRING` - STRING
 */
export enum OutputTypeEnum {
  JSON = "JSON",
  STRING = "STRING",
}

export interface PaginatedEntityResponse {
  count: number;
  next: string | null;
  previous: string | null;
  results: Entity[];
}

export interface PaginatedQueryResponse {
  count: number;
  next: string | null;
  previous: string | null;
  results: Query[];
}

/**
 * * `pending` - Pending
 * * `document_parsing` - Document Parsing
 * * `document_parsed` - Document Parsed
 * * `document_parsing_failed` - Document Parsing Failed
 */
export enum ParsingStatusEnum {
  Pending = "pending",
  DocumentParsing = "document_parsing",
  DocumentParsed = "document_parsed",
  DocumentParsingFailed = "document_parsing_failed",
}

export interface PasswordReset {
  password: string;
  confirm_password: string;
}

export interface PasswordResetEmail {
  email: string;
}

export interface PatchedCreateAndUpdateDatabase {
  /** @maxLength 255 */
  name?: string;
  description?: string;
  is_public?: boolean;
}

/**
 * * `PENDING` - PENDING
 * * `RUNNING` - RUNNING
 * * `COMPLETED` - COMPLETED
 * * `BATCH_PROCESSING` - BATCH_PROCESSING
 * * `FAILED` - FAILED
 * * `CANCELLED` - CANCELLED
 */
export enum PossibleProcessingStatus {
  PENDING = "PENDING",
  RUNNING = "RUNNING",
  COMPLETED = "COMPLETED",
  BATCH_PROCESSING = "BATCH_PROCESSING",
  FAILED = "FAILED",
  CANCELLED = "CANCELLED",
}

export interface PromptTemplate {
  id: number;
  /** @maxLength 255 */
  name: string;
  description: string;
  prompt?: string;
  /** @format date-time */
  created_at: string;
  /** @format date-time */
  updated_at: string;
  type?: Type283Enum | NullEnum | null;
  /**
   * * `JSON` - JSON
   * * `STRING` - STRING
   */
  output_type?: OutputTypeEnum;
  dataset?: number | null;
  account?: number | null;
}

export interface PythonSandboxForDatasets {
  code: string;
  datasets: number[];
}

export interface Query {
  /** @format uuid */
  id: string;
  text: string;
  indexed?: boolean;
  /** @format date-time */
  created_at: string;
  /** @format date-time */
  updated_at: string;
  query_matches: QueryMatch[] | null;
  match_type_counts: Record<string, number>;
  oasis_embedding: Record<string, number | null>;
  normalized_oasis_embedding: Record<string, number | null>;
  /** @format uuid */
  origin_entity?: string | null;
}

export interface QueryMatch {
  entity_id: string;
  /**
   * * `perfect_match` - perfect_match
   * * `good_match` - good_match
   * * `match` - match
   * * `partial_match` - partial_match
   * * `irrelevant` - irrelevant
   * * `contradiction` - contradiction
   */
  match_type: MatchTypeEnum;
}

export interface QueryResultMatch {
  id: number;
  /** @maxLength 255 */
  query: string;
  /** @maxLength 255 */
  type: string;
  action?: number | null;
  /** @format date-time */
  created_at: string;
}

export interface QuerySearchResult {
  query: string;
  oasis_query_embedding: Record<string, any>;
  oasis_weight_embedding?: Record<string, any>;
  entities: Entity[];
}

export interface QueryWeightsResponse {
  weights: Record<string, number>;
  /** @format uuid */
  query_id: string;
  query_text: string;
}

export interface ReadDatabase {
  /** @format uuid */
  id: string;
  /** @maxLength 255 */
  name: string;
  description: string;
  /** @format date-time */
  created_at: string;
  /** @format date-time */
  updated_at: string;
  owner: string;
  oasis_enabled: boolean;
  semantic_enabled: boolean;
  is_public?: boolean;
  primary_entity_collection_id: string;
  live_dimension_collection_id: string;
}

export interface RedownloadBatchLLMJob {
  id: number;
}

export interface RetryLLMJob {
  id: number;
}

export interface Search {
  query: string;
  dataset_id?: number;
}

export interface SearchCollection {
  id: number;
  search_results: SearchResult[];
  /** @maxLength 255 */
  name: string;
  description: string;
  /** @format date-time */
  created_at: string;
  params?: any;
  account?: number | null;
  analysis?: number | null;
}

export interface SearchRequest {
  /** Search query string */
  q: string;
}

export interface SearchResult {
  semantic: Entity[];
  oasis: OasisSearchResult;
}

export interface SemanticIndexRequest {
  id: number;
  /**
   * * `pending` - Pending
   * * `running` - Running
   * * `completed` - Completed
   * * `failed` - Failed
   */
  status?: SemanticIndexRequestStatusEnum;
  /** @format date-time */
  created_at: string;
  /** @format date-time */
  updated_at: string;
}

/**
 * * `pending` - Pending
 * * `running` - Running
 * * `completed` - Completed
 * * `failed` - Failed
 */
export enum SemanticIndexRequestStatusEnum {
  Pending = "pending",
  Running = "running",
  Completed = "completed",
  Failed = "failed",
}

export interface SignupError {
  error: Record<string, string[]>;
}

export interface StripeCheckout {
  slug: string;
}

export interface StripeCheckoutResponse {
  /** @format uri */
  stripe_checkout_url: string;
}

export interface StripePortal {
  /** @format uri */
  stripe_portal_url: string;
}

export interface Submission {
  /** @format uuid */
  id: string;
  fields: SubmissionField[];
  /** @format date-time */
  created_at: string;
  is_test?: boolean;
  is_submitted?: boolean;
  /** @format uuid */
  form: string;
}

export interface SubmissionField {
  /** @format uuid */
  id: string;
  value?: string;
  /** @format uuid */
  submission: string;
  /** @format uuid */
  form_field: string;
}

export interface SubsetCreation {
  dataset_id: number;
  name: string;
  description: string;
  size: number;
  sampling_strategy: string;
  query: string;
}

export interface SyntheticDimensionConfiguration {
  id: number;
  config?: any;
  /** @format date-time */
  created_at: string;
  /** @format date-time */
  updated_at: string;
}

export interface ToggleActionRequest {
  action_id: number;
}

/**
 * * `SYSTEM` - SYSTEM
 * * `USER` - USER
 */
export enum Type283Enum {
  SYSTEM = "SYSTEM",
  USER = "USER",
}

export interface UpdateEntityCollectionMetadataRequest {
  entity_collection_metadata: EntityMetadataResponse;
}

export interface UpdateQuery {
  text?: string;
  query_matches?: QueryMatch[];
  /** @format uuid */
  origin_entity?: string | null;
}

export interface Usage {
  total_pages_used_today: number;
  total_pages_remaining_today: string;
}

export interface User {
  /** @maxLength 150 */
  first_name?: string;
  /** @maxLength 150 */
  last_name?: string;
  /**
   * Email address
   * @format email
   * @maxLength 254
   */
  email?: string;
}

export interface UserAction {
  id: number;
  action: number;
  user: number;
  /** @format date-time */
  created_at: string;
  /** @format date-time */
  updated_at: string;
}

export interface UserActionSettingsResponse {
  enabled_actions: UserAction[];
  owned_actions: Action[];
  default_actions: Action[];
}

export interface UserResponse {
  user: User;
}

export interface UserSignup {
  /** @maxLength 150 */
  first_name?: string;
  /** @maxLength 150 */
  last_name?: string;
  /**
   * Email address
   * @format email
   * @maxLength 254
   */
  email?: string;
  /** @maxLength 128 */
  password: string;
}

export interface VectorOntology {
  id: number;
  dimensions: Dimension[];
  /** @format date-time */
  created_at: string;
  /** @format date-time */
  updated_at: string;
  /** @maxLength 255 */
  name: string;
  description?: string;
  account?: number | null;
}

export interface WebResult {
  id: string;
  title: string;
  url: string;
  text: string;
  profile?: any;
}

import type { AxiosInstance, AxiosRequestConfig, AxiosResponse, HeadersDefaults, ResponseType } from "axios";
import axios from "axios";

export type QueryParamsType = Record<string | number, any>;

export interface FullRequestParams extends Omit<AxiosRequestConfig, "data" | "params" | "url" | "responseType"> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean;
  /** request path */
  path: string;
  /** content type of request body */
  type?: ContentType;
  /** query params */
  query?: QueryParamsType;
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseType;
  /** request body */
  body?: unknown;
}

export type RequestParams = Omit<FullRequestParams, "body" | "method" | "query" | "path">;

export interface ApiConfig<SecurityDataType = unknown> extends Omit<AxiosRequestConfig, "data" | "cancelToken"> {
  securityWorker?: (
    securityData: SecurityDataType | null,
  ) => Promise<AxiosRequestConfig | void> | AxiosRequestConfig | void;
  secure?: boolean;
  format?: ResponseType;
}

export enum ContentType {
  Json = "application/json",
  FormData = "multipart/form-data",
  UrlEncoded = "application/x-www-form-urlencoded",
  Text = "text/plain",
}

export class HttpClient<SecurityDataType = unknown> {
  public instance: AxiosInstance;
  private securityData: SecurityDataType | null = null;
  private securityWorker?: ApiConfig<SecurityDataType>["securityWorker"];
  private secure?: boolean;
  private format?: ResponseType;

  constructor({ securityWorker, secure, format, ...axiosConfig }: ApiConfig<SecurityDataType> = {}) {
    this.instance = axios.create({ ...axiosConfig, baseURL: axiosConfig.baseURL || "" });
    this.secure = secure;
    this.format = format;
    this.securityWorker = securityWorker;
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data;
  };

  protected mergeRequestParams(params1: AxiosRequestConfig, params2?: AxiosRequestConfig): AxiosRequestConfig {
    const method = params1.method || (params2 && params2.method);

    return {
      ...this.instance.defaults,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...((method && this.instance.defaults.headers[method.toLowerCase() as keyof HeadersDefaults]) || {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {}),
      },
    };
  }

  protected stringifyFormItem(formItem: unknown) {
    if (typeof formItem === "object" && formItem !== null) {
      return JSON.stringify(formItem);
    } else {
      return `${formItem}`;
    }
  }

  protected createFormData(input: Record<string, unknown>): FormData {
    if (input instanceof FormData) {
      return input;
    }
    return Object.keys(input || {}).reduce((formData, key) => {
      const property = input[key];
      const propertyContent: any[] = property instanceof Array ? property : [property];

      for (const formItem of propertyContent) {
        const isFileType = formItem instanceof Blob || formItem instanceof File;
        formData.append(key, isFileType ? formItem : this.stringifyFormItem(formItem));
      }

      return formData;
    }, new FormData());
  }

  public request = async <T = any, _E = any>({
    secure,
    path,
    type,
    query,
    format,
    body,
    ...params
  }: FullRequestParams): Promise<AxiosResponse<T>> => {
    const secureParams =
      ((typeof secure === "boolean" ? secure : this.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {};
    const requestParams = this.mergeRequestParams(params, secureParams);
    const responseFormat = format || this.format || undefined;

    if (type === ContentType.FormData && body && body !== null && typeof body === "object") {
      body = this.createFormData(body as Record<string, unknown>);
    }

    if (type === ContentType.Text && body && body !== null && typeof body !== "string") {
      body = JSON.stringify(body);
    }

    return this.instance.request({
      ...requestParams,
      headers: {
        ...(requestParams.headers || {}),
        ...(type ? { "Content-Type": type } : {}),
      },
      params: query,
      responseType: responseFormat,
      data: body,
      url: path,
    });
  };
}

/**
 * @title No title
 * @version 0.0.0
 */
export class OasisBackendApi<SecurityDataType extends unknown> extends HttpClient<SecurityDataType> {
  api = {
    /**
     * No description
     *
     * @tags api
     * @name ApiContactUsCreate
     * @request POST:/api/contact-us/
     * @secure
     */
    apiContactUsCreate: (data: ContactUsResponse, params: RequestParams = {}) =>
      this.request<ContactUsResponse, any>({
        path: `/api/contact-us/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Search multiple queries at once using Oasis search
     *
     * @tags api
     * @name ApiDatabaseBatchSearchCreate
     * @summary Batch Search Queries
     * @request POST:/api/database/{Database_pk}/batch-search/
     * @secure
     */
    apiDatabaseBatchSearchCreate: (
      databasePk: string,
      data: {
        /** List of query strings to search (required for semantic search or when not providing oasis_query_embeddings) */
        queries?: string[];
        /**
         * Type of search to perform
         * @default "oasis"
         */
        type?: "oasis" | "semantic";
        /**
         * Whether to rerank the results
         * @default false
         */
        rerank?: boolean;
        /**
         * Limit the number of results per query
         * @default 50
         */
        limit?: number;
        /**
         * Distance metric to use for Oasis search
         * @default "cosine"
         */
        distance_metric?: "cosine" | "euclidean" | "manhattan";
        /**
         * Whether to use dimension weights for weighted search
         * @default false
         */
        use_oasis_weights?: boolean;
        /** List of Oasis query embeddings (one per query). Each embedding is a dict mapping dimension names to values. If provided, queries array is optional for oasis search. */
        oasis_query_embeddings?: object[];
        /** List of Oasis weight embeddings (one per query). Each embedding is a dict mapping dimension names to weights. If provided, weights will be used directly instead of computing/fetching. */
        oasis_weight_embeddings?: object[];
      },
      params: RequestParams = {},
    ) =>
      this.request<BatchSearchResult, any>({
        path: `/api/database/${databasePk}/batch-search/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Chat with a knowledge base using a query string
     *
     * @tags api
     * @name ApiDatabaseChatCreate
     * @summary Chat with a Knowledge Base
     * @request POST:/api/database/{Database_pk}/chat/
     * @secure
     */
    apiDatabaseChatCreate: (
      databasePk: string,
      data: {
        messages: {
          role: "user" | "assistant";
          content: string;
        }[];
        /**
         * Controls randomness in the response
         * @default 0.7
         */
        temperature?: number;
        /**
         * The model to use for chat completion
         * @default "openai/gpt-4-mini"
         */
        model_name?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ChatResponse, any>({
        path: `/api/database/${databasePk}/chat/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Chat with a knowledge base using a query string
     *
     * @tags api
     * @name ApiDatabaseChatStreamCreate
     * @summary Chat with a Knowledge Base
     * @request POST:/api/database/{Database_pk}/chat-stream/
     * @secure
     */
    apiDatabaseChatStreamCreate: (
      databasePk: string,
      data: {
        messages: {
          role: "user" | "assistant";
          content: string;
        }[];
        /**
         * Controls randomness in the response
         * @default 0.7
         */
        temperature?: number;
        /**
         * The model to use for chat completion
         * @default "openai/gpt-4-mini"
         */
        model_name?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ChatResponse, any>({
        path: `/api/database/${databasePk}/chat-stream/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description List all documents for a knowledge base
     *
     * @tags api
     * @name ApiDatabaseDocumentsList
     * @summary List Documents
     * @request GET:/api/database/{Database_pk}/documents/
     * @secure
     */
    apiDatabaseDocumentsList: (databasePk: string, params: RequestParams = {}) =>
      this.request<Document[], any>({
        path: `/api/database/${databasePk}/documents/`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Upload a document to a knowledge base
     *
     * @tags api
     * @name ApiDatabaseDocumentsCreate
     * @summary Upload a Document
     * @request POST:/api/database/{Database_pk}/documents/
     * @secure
     */
    apiDatabaseDocumentsCreate: (
      databasePk: string,
      data: {
        /** @format binary */
        document_blob: File;
        document_name: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<Document, any>({
        path: `/api/database/${databasePk}/documents/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.FormData,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags api
     * @name ApiDatabaseRetryDocumentParsingCreate
     * @request POST:/api/database/{Database_pk}/retry-document-parsing/
     * @secure
     */
    apiDatabaseRetryDocumentParsingCreate: (databasePk: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/database/${databasePk}/retry-document-parsing/`,
        method: "POST",
        secure: true,
        ...params,
      }),

    /**
     * @description Search documents within a knowledge base using a query string
     *
     * @tags api
     * @name ApiDatabaseSearchCreate
     * @summary Search a Knowledge Base
     * @request POST:/api/database/{Database_pk}/search/
     * @secure
     */
    apiDatabaseSearchCreate: (
      databasePk: string,
      data: {
        /** Search query string (required for semantic search or when not providing oasis_query_embedding) */
        query?: string;
        /**
         * Type of search to perform
         * @default "semantic"
         */
        type?: "semantic" | "oasis";
        /**
         * Whether to rerank the results
         * @default false
         */
        rerank?: boolean;
        /** Oasis query embedding (dict mapping dimension names to values). If provided, query is optional for oasis search. */
        oasis_query_embedding?: object;
        /** Oasis weight embedding (dict mapping dimension names to weights). If provided, weights will be used directly instead of computing/fetching. */
        oasis_weight_embedding?: object;
        /**
         * Limit the number of results
         * @default 50
         */
        limit?: number;
        /**
         * Distance metric to use for Oasis search
         * @default "cosine"
         */
        distance_metric?: "cosine" | "euclidean" | "manhattan";
        /**
         * Whether to use oasis weights
         * @default false
         */
        use_oasis_weights?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<SearchResult, any>({
        path: `/api/database/${databasePk}/search/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Translate a knowledge base to a target language code
     *
     * @tags api
     * @name ApiDatabaseTranslateCreate
     * @summary Translate a Knowledge Base
     * @request POST:/api/database/{Database_pk}/translate/
     * @secure
     */
    apiDatabaseTranslateCreate: (
      databasePk: string,
      data: {
        target_language_code: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/database/${databasePk}/translate/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Create multiple entities at once
     *
     * @tags api
     * @name ApiDatabaseCreateEntitiesCreate
     * @summary Create Entities
     * @request POST:/api/database/{database_id}/create-entities/
     * @secure
     */
    apiDatabaseCreateEntitiesCreate: (databaseId: string, data: CreateEntitiesRequest, params: RequestParams = {}) =>
      this.request<Entity[], any>({
        path: `/api/database/${databaseId}/create-entities/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Generate metadata for entities from a CSV file sample
     *
     * @tags api
     * @name ApiDatabaseGenerateEntityMetadataCreate
     * @summary Generate Entity Metadata
     * @request POST:/api/database/{database_id}/generate-entity-metadata/
     * @secure
     */
    apiDatabaseGenerateEntityMetadataCreate: (
      databaseId: string,
      data: {
        /**
         * CSV file containing entities
         * @format binary
         */
        csv_file: File;
      },
      params: RequestParams = {},
    ) =>
      this.request<EntityMetadataResponse, any>({
        path: `/api/database/${databaseId}/generate-entity-metadata/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.FormData,
        format: "json",
        ...params,
      }),

    /**
     * @description Index an entity collection on the current dimension collection
     *
     * @tags api
     * @name ApiDatabaseIndexEntityCollectionOnCurrentDimensionCollectionCreate
     * @summary Index an Entity Collection on the Current Dimension Collection
     * @request POST:/api/database/{database_id}/index-entity-collection-on-current-dimension-collection/
     * @secure
     */
    apiDatabaseIndexEntityCollectionOnCurrentDimensionCollectionCreate: (
      databaseId: string,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/database/${databaseId}/index-entity-collection-on-current-dimension-collection/`,
        method: "POST",
        secure: true,
        ...params,
      }),

    /**
     * @description Update the metadata for an entity collection
     *
     * @tags api
     * @name ApiDatabaseUpdateEntityCollectionMetadataCreate
     * @summary Update Entity Collection Metadata
     * @request POST:/api/database/{database_id}/update-entity-collection-metadata/
     * @secure
     */
    apiDatabaseUpdateEntityCollectionMetadataCreate: (
      databaseId: string,
      data: UpdateEntityCollectionMetadataRequest,
      params: RequestParams = {},
    ) =>
      this.request<EntityCollection, any>({
        path: `/api/database/${databaseId}/update-entity-collection-metadata/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Upload entities to a database
     *
     * @tags api
     * @name ApiDatabaseUploadEntitiesCreate
     * @summary Upload Entities
     * @request POST:/api/database/{database_id}/upload-entities/
     * @secure
     */
    apiDatabaseUploadEntitiesCreate: (
      databaseId: string,
      data: {
        /** Metadata for the entity collection */
        entity_collection_metadata: object;
        /**
         * CSV file containing entities
         * @format binary
         */
        csv_file: File;
      },
      params: RequestParams = {},
    ) =>
      this.request<EntityCollection, any>({
        path: `/api/database/${databaseId}/upload-entities/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.FormData,
        format: "json",
        ...params,
      }),

    /**
     * @description Write a dimension collection
     *
     * @tags api
     * @name ApiDatabaseWriteDimensionCollectionCreate
     * @summary Write a Dimension Collection
     * @request POST:/api/database/{database_id}/write-dimension-collection/
     * @secure
     */
    apiDatabaseWriteDimensionCollectionCreate: (databaseId: string, data: string[], params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/database/${databaseId}/write-dimension-collection/`,
        method: "POST",
        body: data,
        secure: true,
        ...params,
      }),

    /**
     * @description Get an entity collection by ID
     *
     * @tags api
     * @name ApiDatabaseEntityCollectionRetrieve
     * @summary Get an Entity Collection
     * @request GET:/api/database/{id}/entity-collection/
     * @secure
     */
    apiDatabaseEntityCollectionRetrieve: (id: string, params: RequestParams = {}) =>
      this.request<EntityCollection, any>({
        path: `/api/database/${id}/entity-collection/`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Get all entities in an entity collection with pagination
     *
     * @tags api
     * @name ApiDatabaseEntityCollectionAllEntitiesRetrieve
     * @summary Get all entities in an Entity Collection
     * @request GET:/api/database/{id}/entity-collection/all-entities/
     * @secure
     */
    apiDatabaseEntityCollectionAllEntitiesRetrieve: (
      id: string,
      query?: {
        /**
         * Page number
         * @default 1
         */
        page?: number;
        /**
         * Number of entities per page
         * @default 50
         */
        page_size?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<PaginatedEntityResponse, any>({
        path: `/api/database/${id}/entity-collection/all-entities/`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Index an entity collection
     *
     * @tags api
     * @name ApiDatabaseIndexEntityCollectionCreate
     * @summary Index an Entity Collection
     * @request POST:/api/database/{id}/index-entity-collection/
     * @secure
     */
    apiDatabaseIndexEntityCollectionCreate: (
      id: string,
      data: {
        index_type: "semantic" | "oasis";
        /** Configuration dictionary for indexing. For oasis index type, can include: entity_min (default: 100), max_dimensions (default: 25), candidate_dimensions (default: 100), distance_metric (default: cosine), and any other future configuration options. */
        config?: {
          /** Minimum number of entities required for indexing */
          entity_min?: number;
          /** Maximum number of dimensions to select */
          max_dimensions?: number;
          /** Number of candidate dimensions to generate */
          candidate_dimensions?: number;
          /**
           * Distance metric to use for dimension selection
           * @default "cosine"
           */
          distance_metric?: "cosine" | "euclidean" | "manhattan";
        };
      },
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/database/${id}/index-entity-collection/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Redo only the selection step of oasis indexing using the exact same queries, entities, and candidate dimensions from a previous completed oasis index request, with potentially different parameters (e.g., max_dimensions).
     *
     * @tags api
     * @name ApiDatabaseRedoOasisIndexSelectionCreate
     * @summary Redo Oasis Index Selection
     * @request POST:/api/database/{id}/redo-oasis-index-selection/
     * @secure
     */
    apiDatabaseRedoOasisIndexSelectionCreate: (
      id: string,
      data: {
        /**
         * ID of the source oasis index request to recover state from. If not provided, uses the latest completed request for the entity collection.
         * @format uuid
         */
        source_request_id?: string;
        /** Configuration dictionary for redo selection. Can include: max_dimensions (default: 25), entity_min (default: 100), distance_metric (default: cosine). */
        config?: {
          /** Maximum number of dimensions to select */
          max_dimensions?: number;
          /** Minimum number of entities required */
          entity_min?: number;
          /**
           * Distance metric to use for dimension selection
           * @default "cosine"
           */
          distance_metric?: "cosine" | "euclidean" | "manhattan";
        };
      },
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/database/${id}/redo-oasis-index-selection/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Get a list of knowledge bases owned by the authenticated user or create a new one
     *
     * @tags api
     * @name ApiDatabasesList
     * @summary List and Create Knowledge Bases
     * @request GET:/api/databases/
     * @secure
     */
    apiDatabasesList: (params: RequestParams = {}) =>
      this.request<ReadDatabase[], any>({
        path: `/api/databases/`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Create a new knowledge base
     *
     * @tags api
     * @name ApiDatabasesCreate
     * @summary Create a Knowledge Base
     * @request POST:/api/databases/
     * @secure
     */
    apiDatabasesCreate: (data: CreateAndUpdateDatabase, params: RequestParams = {}) =>
      this.request<ReadDatabase, any>({
        path: `/api/databases/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Get details of a specific knowledge base
     *
     * @tags api
     * @name ApiDatabasesRetrieve
     * @summary Retrieve a Knowledge Base
     * @request GET:/api/databases/{id}/
     * @secure
     */
    apiDatabasesRetrieve: (id: string, params: RequestParams = {}) =>
      this.request<ReadDatabase, any>({
        path: `/api/databases/${id}/`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Update an existing knowledge base (owner only)
     *
     * @tags api
     * @name ApiDatabasesUpdate
     * @summary Update a Knowledge Base
     * @request PUT:/api/databases/{id}/
     * @secure
     */
    apiDatabasesUpdate: (id: string, data: CreateAndUpdateDatabase, params: RequestParams = {}) =>
      this.request<CreateAndUpdateDatabase, any>({
        path: `/api/databases/${id}/`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Partially update an existing knowledge base (owner only)
     *
     * @tags api
     * @name ApiDatabasesPartialUpdate
     * @summary Partially Update a Knowledge Base
     * @request PATCH:/api/databases/{id}/
     * @secure
     */
    apiDatabasesPartialUpdate: (id: string, data: PatchedCreateAndUpdateDatabase, params: RequestParams = {}) =>
      this.request<CreateAndUpdateDatabase, any>({
        path: `/api/databases/${id}/`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Delete an existing knowledge base
     *
     * @tags api
     * @name ApiDatabasesDestroy
     * @summary Delete a Knowledge Base
     * @request DELETE:/api/databases/{id}/
     * @secure
     */
    apiDatabasesDestroy: (id: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/databases/${id}/`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * @description Get a dimension collection by ID
     *
     * @tags api
     * @name ApiDimensionCollectionRetrieve
     * @summary Get a Dimension Collection
     * @request GET:/api/dimension-collection/{dimension_collection_id}/
     * @secure
     */
    apiDimensionCollectionRetrieve: (dimensionCollectionId: string, params: RequestParams = {}) =>
      this.request<DimensionCollection, any>({
        path: `/api/dimension-collection/${dimensionCollectionId}/`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Set an existing (previously live) dimension collection as live again, triggering re-indexing
     *
     * @tags api
     * @name ApiDimensionCollectionReactivateCreate
     * @summary Reactivate a Dimension Collection
     * @request POST:/api/dimension-collection/{dimension_collection_id}/reactivate/
     * @secure
     */
    apiDimensionCollectionReactivateCreate: (dimensionCollectionId: string, params: RequestParams = {}) =>
      this.request<DimensionCollection, any>({
        path: `/api/dimension-collection/${dimensionCollectionId}/reactivate/`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Delete a dimension by ID. Cannot delete if dimension is part of a live dimension collection.
     *
     * @tags api
     * @name ApiDimensionsDestroy
     * @summary Delete Dimension
     * @request DELETE:/api/dimensions/{dimension_id}/
     * @secure
     */
    apiDimensionsDestroy: (dimensionId: string, params: RequestParams = {}) =>
      this.request<void, void>({
        path: `/api/dimensions/${dimensionId}/`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * @description Retrieve a document by ID
     *
     * @tags api
     * @name ApiDocumentsRetrieve
     * @summary Retrieve a Document
     * @request GET:/api/documents/{id}/
     * @secure
     */
    apiDocumentsRetrieve: (id: string, params: RequestParams = {}) =>
      this.request<DetailedDocument, any>({
        path: `/api/documents/${id}/`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Delete a document by ID
     *
     * @tags api
     * @name ApiDocumentsDestroy
     * @summary Delete a Document
     * @request DELETE:/api/documents/{id}/
     * @secure
     */
    apiDocumentsDestroy: (id: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/documents/${id}/`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * @description Delete an entity by ID. Only allowed for entities in databases owned by the user.
     *
     * @tags api
     * @name ApiEntitiesDestroy
     * @summary Delete an Entity
     * @request DELETE:/api/entities/{entity_id}/
     * @secure
     */
    apiEntitiesDestroy: (entityId: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/entities/${entityId}/`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * @description Compute weighted-rank scores for all queries with matches in an entity collection, then aggregate stats for multiple k values (1, 3, 5, 10, 20, 50, 100 up to the limit). Stats are organized by k value.
     *
     * @tags api
     * @name ApiEntityCollectionBenchmarkRetrieve
     * @summary Benchmark semantic vs oasis on queries
     * @request GET:/api/entity-collection/{entity_collection_id}/benchmark/
     * @secure
     */
    apiEntityCollectionBenchmarkRetrieve: (
      entityCollectionId: string,
      query?: {
        /**
         * Maximum k value to retrieve and test (default: 50). Tests k values: 1, 3, 5, 10, 20, 50, 100 (up to limit).
         * @default 50
         */
        limit?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<BenchmarkSummaryResponse, any>({
        path: `/api/entity-collection/${entityCollectionId}/benchmark/`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Create a new dimension collection with specified dimensions and activate it by indexing the entity collection
     *
     * @tags api
     * @name ApiEntityCollectionCreateActivatedDimensionCollectionCreate
     * @summary Create an Activated Dimension Collection
     * @request POST:/api/entity-collection/{entity_collection_id}/create-activated-dimension-collection/
     * @secure
     */
    apiEntityCollectionCreateActivatedDimensionCollectionCreate: (
      entityCollectionId: string,
      data: string[],
      params: RequestParams = {},
    ) =>
      this.request<DimensionCollection, any>({
        path: `/api/entity-collection/${entityCollectionId}/create-activated-dimension-collection/`,
        method: "POST",
        body: data,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Create multiple queries at once
     *
     * @tags api
     * @name ApiEntityCollectionCreateQueriesCreate
     * @summary Create Queries
     * @request POST:/api/entity-collection/{entity_collection_id}/create-queries/
     * @secure
     */
    apiEntityCollectionCreateQueriesCreate: (
      entityCollectionId: string,
      data: {
        queries: {
          text: string;
          /**
           * Optional origin entity ID
           * @format uuid
           */
          origin_entity?: string;
          /** List of entity matches with their match types */
          query_matches?: {
            /** @format uuid */
            entity_id: string;
            match_type: "perfect_match" | "good_match" | "match" | "partial_match" | "irrelevant" | "contradiction";
          }[];
        }[];
      },
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/entity-collection/${entityCollectionId}/create-queries/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Get comprehensive analytics for dimensions in an entity collection including histograms, correlation matrices, type analysis, scores from last oasis index request, and information-theoretic metrics (entropy, mutual information, conditional entropy)
     *
     * @tags api
     * @name ApiEntityCollectionDimensionAnalyticsRetrieve
     * @summary Get Dimension Analytics
     * @request GET:/api/entity-collection/{entity_collection_id}/dimension-analytics/
     * @secure
     */
    apiEntityCollectionDimensionAnalyticsRetrieve: (
      entityCollectionId: string,
      query?: {
        /**
         * Filter dimensions: 'live' (default) for live collection only, 'all' for all dimensions
         * @default "live"
         */
        dimension_filter?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<DimensionAnalyticsResponse, any>({
        path: `/api/entity-collection/${entityCollectionId}/dimension-analytics/`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description List all dimension collections for an entity collection, including live history timelines
     *
     * @tags api
     * @name ApiEntityCollectionDimensionCollectionsList
     * @summary List Dimension Collections
     * @request GET:/api/entity-collection/{entity_collection_id}/dimension-collections/
     * @secure
     */
    apiEntityCollectionDimensionCollectionsList: (entityCollectionId: string, params: RequestParams = {}) =>
      this.request<DimensionCollection[], any>({
        path: `/api/entity-collection/${entityCollectionId}/dimension-collections/`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Get all dimensions associated with all dimension collections for an entity collection
     *
     * @tags api
     * @name ApiEntityCollectionDimensionsList
     * @summary Get Entity Collection Dimensions
     * @request GET:/api/entity-collection/{entity_collection_id}/dimensions/
     * @secure
     */
    apiEntityCollectionDimensionsList: (entityCollectionId: string, params: RequestParams = {}) =>
      this.request<Dimension[], any>({
        path: `/api/entity-collection/${entityCollectionId}/dimensions/`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Create a new dimension with a new dimension collection
     *
     * @tags api
     * @name ApiEntityCollectionDimensionsCreateCreate
     * @summary Create Dimension
     * @request POST:/api/entity-collection/{entity_collection_id}/dimensions/create/
     * @secure
     */
    apiEntityCollectionDimensionsCreateCreate: (
      entityCollectionId: string,
      data: {
        /** Name of the dimension */
        name: string;
        /** Description of the dimension */
        description: string;
        /**
         * Type of dimension (likert, timestamp, number, boolean, ordered_category, etc.)
         * @default "likert"
         */
        dimension_type?: string;
        /** Type-specific arguments. For ordered_category: {order: string[], value_mapping: {string: number}} */
        args?: Record<string, any>;
      },
      params: RequestParams = {},
    ) =>
      this.request<Dimension, any>({
        path: `/api/entity-collection/${entityCollectionId}/dimensions/create/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Get n closest neighbours for each entity and most isolated entities based on distance metric
     *
     * @tags api
     * @name ApiEntityCollectionEntityNeighboursRetrieve
     * @summary Get Entity Neighbours and Isolated Entities
     * @request GET:/api/entity-collection/{entity_collection_id}/entity-neighbours/
     * @secure
     */
    apiEntityCollectionEntityNeighboursRetrieve: (
      entityCollectionId: string,
      query?: {
        /**
         * Distance metric: 'cosine', 'euclidean', or 'manhattan'
         * @default "cosine"
         */
        distance_metric?: string;
        /**
         * Number of most isolated entities to return (furthest from their closest neighbour)
         * @default 20
         */
        top_isolated?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<EntityNeighboursResponse, any>({
        path: `/api/entity-collection/${entityCollectionId}/entity-neighbours/`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Analyze whether entities that are more isolated (unique) in the embedding space are easier or harder to find in search. Isolation is measured as the distance to the nearest neighbor in the embedding space. Entities with high isolation are truly unique - they don't have other similar entities nearby. This samples entities across the isolation distribution to ensure balanced analysis, then runs searches using their associated queries and captures the rank of each entity. A negative correlation suggests that isolated/unique entities are easier to find. A positive correlation suggests that isolated entities are harder to find (outliers).
     *
     * @tags api
     * @name ApiEntityCollectionEntropyRankCorrelationRetrieve
     * @summary Analyze Isolation-Rank Correlation
     * @request GET:/api/entity-collection/{entity_collection_id}/entropy-rank-correlation/
     * @secure
     */
    apiEntityCollectionEntropyRankCorrelationRetrieve: (
      entityCollectionId: string,
      query?: {
        /**
         * Distance metric for isolation: 'cosine', 'euclidean', or 'manhattan'
         * @default "cosine"
         */
        distance_metric?: string;
        /**
         * Number of isolation bins (quintiles by default)
         * @default 5
         */
        n_bins?: number;
        /**
         * Number of entities to sample from each isolation bin
         * @default 10
         */
        n_samples_per_bin?: number;
        /**
         * Search type: 'oasis' or 'semantic'
         * @default "oasis"
         */
        search_type?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<EntropyRankCorrelationResponse, any>({
        path: `/api/entity-collection/${entityCollectionId}/entropy-rank-correlation/`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description List the 10 most recent index requests for a specific entity collection
     *
     * @tags api
     * @name ApiEntityCollectionIndexRequestsRetrieve
     * @summary List Index Requests
     * @request GET:/api/entity-collection/{entity_collection_id}/index-requests/
     * @secure
     */
    apiEntityCollectionIndexRequestsRetrieve: (entityCollectionId: string, params: RequestParams = {}) =>
      this.request<IndexRequestsResponse, void>({
        path: `/api/entity-collection/${entityCollectionId}/index-requests/`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description List all queries for an entity collection with pagination
     *
     * @tags api
     * @name ApiEntityCollectionQueriesRetrieve
     * @summary List Queries
     * @request GET:/api/entity-collection/{entity_collection_id}/queries/
     * @secure
     */
    apiEntityCollectionQueriesRetrieve: (
      entityCollectionId: string,
      query?: {
        /**
         * Include query_matches in response (slower)
         * @default false
         */
        include_query_matches?: boolean;
        /**
         * Page number
         * @default 1
         */
        page?: number;
        /**
         * Number of queries per page
         * @default 50
         */
        page_size?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<PaginatedQueryResponse, any>({
        path: `/api/entity-collection/${entityCollectionId}/queries/`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Get a query by its text and entity collection
     *
     * @tags api
     * @name ApiEntityCollectionQueryByTextRetrieve
     * @summary Get Query by Text
     * @request GET:/api/entity-collection/{entity_collection_id}/query-by-text/
     * @secure
     */
    apiEntityCollectionQueryByTextRetrieve: (
      entityCollectionId: string,
      query?: {
        /** Query text to search for */
        text?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<Query, void>({
        path: `/api/entity-collection/${entityCollectionId}/query-by-text/`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Get a list of all API tokens belonging to the authenticated user
     *
     * @tags api
     * @name ApiPublicPrivateKeyRetrieve
     * @summary List all tokens for the authenticated user
     * @request GET:/api/public-private-key/
     * @secure
     */
    apiPublicPrivateKeyRetrieve: (params: RequestParams = {}) =>
      this.request<
        {
          id: number;
          public_key: string;
          name: string;
          /** @format date-time */
          created_at: string;
        }[],
        any
      >({
        path: `/api/public-private-key/`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Roll a new token for the authenticated user
     *
     * @tags api
     * @name ApiPublicPrivateKeyCreate
     * @summary Roll a new token
     * @request POST:/api/public-private-key/
     * @secure
     */
    apiPublicPrivateKeyCreate: (params: RequestParams = {}) =>
      this.request<
        {
          public_token: string;
          private_token: string;
        },
        any
      >({
        path: `/api/public-private-key/`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Delete all tokens for the authenticated user
     *
     * @tags api
     * @name ApiPublicPrivateKeyDeleteDestroy
     * @summary Delete all tokens
     * @request DELETE:/api/public-private-key/{named_account_token_id}/delete/
     * @secure
     */
    apiPublicPrivateKeyDeleteDestroy: (namedAccountTokenId: number, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/public-private-key/${namedAccountTokenId}/delete/`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * @description Get a specific query by ID
     *
     * @tags api
     * @name ApiQueriesRetrieve
     * @summary Get Query
     * @request GET:/api/queries/{query_id}/
     * @secure
     */
    apiQueriesRetrieve: (queryId: string, params: RequestParams = {}) =>
      this.request<Query, any>({
        path: `/api/queries/${queryId}/`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Update a specific query by ID
     *
     * @tags api
     * @name ApiQueriesUpdate
     * @summary Update Query
     * @request PUT:/api/queries/{query_id}/
     * @secure
     */
    apiQueriesUpdate: (queryId: string, data: UpdateQuery, params: RequestParams = {}) =>
      this.request<Query, any>({
        path: `/api/queries/${queryId}/`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Delete a specific query by ID
     *
     * @tags api
     * @name ApiQueriesDestroy
     * @summary Delete Query
     * @request DELETE:/api/queries/{query_id}/
     * @secure
     */
    apiQueriesDestroy: (queryId: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/queries/${queryId}/`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * @description Get dimension weights for a specific query
     *
     * @tags api
     * @name ApiQueriesWeightsRetrieve
     * @summary Get Query Dimension Weights
     * @request GET:/api/queries/{query_id}/weights/
     * @secure
     */
    apiQueriesWeightsRetrieve: (queryId: string, params: RequestParams = {}) =>
      this.request<QueryWeightsResponse, any>({
        path: `/api/queries/${queryId}/weights/`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Get the metadata of an OasisIndexRequest. This endpoint is restricted to staff members only.
     *
     * @tags api
     * @name ApiStaffOasisIndexRequestMetadataRetrieve
     * @summary Get OasisIndexRequest Metadata (Staff Only)
     * @request GET:/api/staff/oasis-index-request/{oasis_index_request_id}/metadata/
     * @secure
     */
    apiStaffOasisIndexRequestMetadataRetrieve: (oasisIndexRequestId: number, params: RequestParams = {}) =>
      this.request<OasisIndexRequestMetadataResponse, void>({
        path: `/api/staff/oasis-index-request/${oasisIndexRequestId}/metadata/`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Get usage information for the authenticated user
     *
     * @tags api
     * @name ApiUsageRetrieve
     * @summary Get usage information
     * @request GET:/api/usage/
     * @secure
     */
    apiUsageRetrieve: (params: RequestParams = {}) =>
      this.request<Usage, any>({
        path: `/api/usage/`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags api
     * @name ApiWaitlistCreate
     * @request POST:/api/waitlist/
     * @secure
     */
    apiWaitlistCreate: (data: APIWaitlist, params: RequestParams = {}) =>
      this.request<APIWaitlist, any>({
        path: `/api/waitlist/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  authorize = {
    /**
     * No description
     *
     * @tags authorize
     * @name AuthorizeRetrieve
     * @request GET:/authorize/
     * @secure
     */
    authorizeRetrieve: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/authorize/`,
        method: "GET",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags authorize
     * @name AuthorizeCreate
     * @request POST:/authorize/
     * @secure
     */
    authorizeCreate: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/authorize/`,
        method: "POST",
        secure: true,
        ...params,
      }),
  };
  csrfToken = {
    /**
     * No description
     *
     * @tags csrf_token
     * @name CsrfTokenCreate
     * @request POST:/csrf_token/
     * @secure
     */
    csrfTokenCreate: (params: RequestParams = {}) =>
      this.request<void, void>({
        path: `/csrf_token/`,
        method: "POST",
        secure: true,
        ...params,
      }),
  };
  dataProcessing = {
    /**
     * No description
     *
     * @tags data-processing
     * @name DataProcessingCreate
     * @request POST:/data-processing/
     * @secure
     */
    dataProcessingCreate: (data: DataProcessingRequest, params: RequestParams = {}) =>
      this.request<DataProcessingResponse, any>({
        path: `/data-processing/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  dataSetConfiguration = {
    /**
     * @description This view returns the DATA_SET_CONFIGURATION for frontend configuration.
     *
     * @tags data-set-configuration
     * @name DataSetConfigurationRetrieve
     * @request GET:/data-set-configuration/
     * @secure
     */
    dataSetConfigurationRetrieve: (params: RequestParams = {}) =>
      this.request<DataSetConfigurationResponse, any>({
        path: `/data-set-configuration/`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),
  };
  euFundingSource = {
    /**
     * No description
     *
     * @tags eu-funding-source
     * @name EuFundingSourceRetrieve
     * @request GET:/eu-funding-source/{id}/
     * @secure
     */
    euFundingSourceRetrieve: (id: number, params: RequestParams = {}) =>
      this.request<EUFundingSource, any>({
        path: `/eu-funding-source/${id}/`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),
  };
  euFundingHybridParallelSearch = {
    /**
     * No description
     *
     * @tags eu_funding_hybrid_parallel_search
     * @name EuFundingHybridParallelSearchCreate
     * @request POST:/eu_funding_hybrid_parallel_search/
     * @secure
     */
    euFundingHybridParallelSearchCreate: (data: EUFunctionDimensionRequest, params: RequestParams = {}) =>
      this.request<EUFunctionDimensionResponse, any>({
        path: `/eu_funding_hybrid_parallel_search/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  euFundingOasisSearch = {
    /**
     * No description
     *
     * @tags eu_funding_oasis_search
     * @name EuFundingOasisSearchCreate
     * @request POST:/eu_funding_oasis_search/
     * @secure
     */
    euFundingOasisSearchCreate: (data: EUFunctionDimensionRequest, params: RequestParams = {}) =>
      this.request<EUFunctionDimensionResponse, any>({
        path: `/eu_funding_oasis_search/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  euFundingTraditionalRag = {
    /**
     * No description
     *
     * @tags eu_funding_traditional_rag
     * @name EuFundingTraditionalRagRetrieve
     * @request GET:/eu_funding_traditional_rag/
     * @secure
     */
    euFundingTraditionalRagRetrieve: (params: RequestParams = {}) =>
      this.request<EUFundingSource, any>({
        path: `/eu_funding_traditional_rag/`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),
  };
  externalOauthToken = {
    /**
     * No description
     *
     * @tags external-oauth-token
     * @name ExternalOauthTokenCreate
     * @request POST:/external-oauth-token/
     * @secure
     */
    externalOauthTokenCreate: (data: CreateExternalOAuthTokenRequest, params: RequestParams = {}) =>
      this.request<CreateExternalOAuthTokenResponse, any>({
        path: `/external-oauth-token/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  feistyforms = {
    /**
     * No description
     *
     * @tags feistyforms
     * @name FeistyformsApiCoPilotCreate
     * @request POST:/feistyforms/api/co-pilot/
     * @secure
     */
    feistyformsApiCoPilotCreate: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/feistyforms/api/co-pilot/`,
        method: "POST",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags feistyforms
     * @name FeistyformsApiCoPilotFormattedCreate
     * @request POST:/feistyforms/api/co-pilot{format}
     * @secure
     */
    feistyformsApiCoPilotFormattedCreate: (format: ".json", params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/feistyforms/api/co-pilot${format}`,
        method: "POST",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags feistyforms
     * @name FeistyformsApiConversationCreate
     * @request POST:/feistyforms/api/conversation/
     * @secure
     */
    feistyformsApiConversationCreate: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/feistyforms/api/conversation/`,
        method: "POST",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags feistyforms
     * @name FeistyformsApiConversationFormattedCreate
     * @request POST:/feistyforms/api/conversation{format}
     * @secure
     */
    feistyformsApiConversationFormattedCreate: (format: ".json", params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/feistyforms/api/conversation${format}`,
        method: "POST",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags feistyforms
     * @name FeistyformsApiCreateFormCreate
     * @request POST:/feistyforms/api/create-form/
     * @secure
     */
    feistyformsApiCreateFormCreate: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/feistyforms/api/create-form/`,
        method: "POST",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags feistyforms
     * @name FeistyformsApiCreateFormFormattedCreate
     * @request POST:/feistyforms/api/create-form{format}
     * @secure
     */
    feistyformsApiCreateFormFormattedCreate: (format: ".json", params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/feistyforms/api/create-form${format}`,
        method: "POST",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags feistyforms
     * @name FeistyformsApiEditFormCreate
     * @request POST:/feistyforms/api/edit-form/{form_id}/
     * @secure
     */
    feistyformsApiEditFormCreate: (formId: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/feistyforms/api/edit-form/${formId}/`,
        method: "POST",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags feistyforms
     * @name FeistyformsApiEditFormFormattedCreate
     * @request POST:/feistyforms/api/edit-form/{form_id}{format}
     * @secure
     */
    feistyformsApiEditFormFormattedCreate: (formId: string, format: ".json", params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/feistyforms/api/edit-form/${formId}${format}`,
        method: "POST",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags feistyforms
     * @name FeistyformsApiEnrichAllSubmissionsCreate
     * @request POST:/feistyforms/api/enrich-all-submissions/{form_id}/
     * @secure
     */
    feistyformsApiEnrichAllSubmissionsCreate: (
      formId: string,
      data: {
        form_id?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<Form, any>({
        path: `/feistyforms/api/enrich-all-submissions/${formId}/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags feistyforms
     * @name FeistyformsApiEnrichAllSubmissionsFormattedCreate
     * @request POST:/feistyforms/api/enrich-all-submissions/{form_id}{format}
     * @secure
     */
    feistyformsApiEnrichAllSubmissionsFormattedCreate: (
      formId: string,
      format: ".json",
      data: {
        form_id?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<Form, any>({
        path: `/feistyforms/api/enrich-all-submissions/${formId}${format}`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags feistyforms
     * @name FeistyformsApiEnrichSubmissionCreate
     * @request POST:/feistyforms/api/enrich-submission/{submission_id}/
     * @secure
     */
    feistyformsApiEnrichSubmissionCreate: (
      submissionId: string,
      data: {
        submission_id?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<Submission, any>({
        path: `/feistyforms/api/enrich-submission/${submissionId}/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags feistyforms
     * @name FeistyformsApiEnrichSubmissionFormattedCreate
     * @request POST:/feistyforms/api/enrich-submission/{submission_id}{format}
     * @secure
     */
    feistyformsApiEnrichSubmissionFormattedCreate: (
      format: ".json",
      submissionId: string,
      data: {
        submission_id?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<Submission, any>({
        path: `/feistyforms/api/enrich-submission/${submissionId}${format}`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags feistyforms
     * @name FeistyformsApiGetConsentRetrieve
     * @request GET:/feistyforms/api/get-consent/{form_id}/
     * @secure
     */
    feistyformsApiGetConsentRetrieve: (formId: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/feistyforms/api/get-consent/${formId}/`,
        method: "GET",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags feistyforms
     * @name FeistyformsApiGetConsentFormattedRetrieve
     * @request GET:/feistyforms/api/get-consent/{form_id}{format}
     * @secure
     */
    feistyformsApiGetConsentFormattedRetrieve: (formId: string, format: ".json", params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/feistyforms/api/get-consent/${formId}${format}`,
        method: "GET",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags feistyforms
     * @name FeistyformsApiGetFormTitleRetrieve
     * @request GET:/feistyforms/api/get-form-title/{form_id}/
     * @secure
     */
    feistyformsApiGetFormTitleRetrieve: (formId: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/feistyforms/api/get-form-title/${formId}/`,
        method: "GET",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags feistyforms
     * @name FeistyformsApiGetFormTitleFormattedRetrieve
     * @request GET:/feistyforms/api/get-form-title/{form_id}{format}
     * @secure
     */
    feistyformsApiGetFormTitleFormattedRetrieve: (formId: string, format: ".json", params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/feistyforms/api/get-form-title/${formId}${format}`,
        method: "GET",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags feistyforms
     * @name FeistyformsApiGetFormRetrieve
     * @request GET:/feistyforms/api/get-form/{form_id}/
     * @secure
     */
    feistyformsApiGetFormRetrieve: (formId: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/feistyforms/api/get-form/${formId}/`,
        method: "GET",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags feistyforms
     * @name FeistyformsApiGetFormFormattedRetrieve
     * @request GET:/feistyforms/api/get-form/{form_id}{format}
     * @secure
     */
    feistyformsApiGetFormFormattedRetrieve: (formId: string, format: ".json", params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/feistyforms/api/get-form/${formId}${format}`,
        method: "GET",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags feistyforms
     * @name FeistyformsApiGetSingleSubmissionRetrieve
     * @request GET:/feistyforms/api/get-single-submission/{conversation_id}/
     * @secure
     */
    feistyformsApiGetSingleSubmissionRetrieve: (conversationId: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/feistyforms/api/get-single-submission/${conversationId}/`,
        method: "GET",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags feistyforms
     * @name FeistyformsApiGetSingleSubmissionFormattedRetrieve
     * @request GET:/feistyforms/api/get-single-submission/{conversation_id}{format}
     * @secure
     */
    feistyformsApiGetSingleSubmissionFormattedRetrieve: (
      conversationId: string,
      format: ".json",
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/feistyforms/api/get-single-submission/${conversationId}${format}`,
        method: "GET",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags feistyforms
     * @name FeistyformsApiGetSubmissionConversationRetrieve
     * @request GET:/feistyforms/api/get-submission-conversation/{submission_id}/
     * @secure
     */
    feistyformsApiGetSubmissionConversationRetrieve: (submissionId: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/feistyforms/api/get-submission-conversation/${submissionId}/`,
        method: "GET",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags feistyforms
     * @name FeistyformsApiGetSubmissionConversationFormattedRetrieve
     * @request GET:/feistyforms/api/get-submission-conversation/{submission_id}{format}
     * @secure
     */
    feistyformsApiGetSubmissionConversationFormattedRetrieve: (
      format: ".json",
      submissionId: string,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/feistyforms/api/get-submission-conversation/${submissionId}${format}`,
        method: "GET",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags feistyforms
     * @name FeistyformsApiGetSubscriptionStatusRetrieve
     * @request GET:/feistyforms/api/get-subscription-status/
     * @secure
     */
    feistyformsApiGetSubscriptionStatusRetrieve: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/feistyforms/api/get-subscription-status/`,
        method: "GET",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags feistyforms
     * @name FeistyformsApiGetSubscriptionStatusFormattedRetrieve
     * @request GET:/feistyforms/api/get-subscription-status{format}
     * @secure
     */
    feistyformsApiGetSubscriptionStatusFormattedRetrieve: (format: ".json", params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/feistyforms/api/get-subscription-status${format}`,
        method: "GET",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags feistyforms
     * @name FeistyformsApiGetUserFormsRetrieve
     * @request GET:/feistyforms/api/get-user-forms/
     * @secure
     */
    feistyformsApiGetUserFormsRetrieve: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/feistyforms/api/get-user-forms/`,
        method: "GET",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags feistyforms
     * @name FeistyformsApiGetUserFormsFormattedRetrieve
     * @request GET:/feistyforms/api/get-user-forms{format}
     * @secure
     */
    feistyformsApiGetUserFormsFormattedRetrieve: (format: ".json", params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/feistyforms/api/get-user-forms${format}`,
        method: "GET",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags feistyforms
     * @name FeistyformsApiRenderFormRetrieve
     * @request GET:/feistyforms/api/render-form/{form_id}/
     * @secure
     */
    feistyformsApiRenderFormRetrieve: (formId: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/feistyforms/api/render-form/${formId}/`,
        method: "GET",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags feistyforms
     * @name FeistyformsApiRenderFormFormattedRetrieve
     * @request GET:/feistyforms/api/render-form/{form_id}{format}
     * @secure
     */
    feistyformsApiRenderFormFormattedRetrieve: (formId: string, format: ".json", params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/feistyforms/api/render-form/${formId}${format}`,
        method: "GET",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags feistyforms
     * @name FeistyformsApiViewResultsRetrieve
     * @request GET:/feistyforms/api/view-results/{form_id}/
     * @secure
     */
    feistyformsApiViewResultsRetrieve: (formId: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/feistyforms/api/view-results/${formId}/`,
        method: "GET",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags feistyforms
     * @name FeistyformsApiViewResultsFormattedRetrieve
     * @request GET:/feistyforms/api/view-results/{form_id}{format}
     * @secure
     */
    feistyformsApiViewResultsFormattedRetrieve: (formId: string, format: ".json", params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/feistyforms/api/view-results/${formId}${format}`,
        method: "GET",
        secure: true,
        ...params,
      }),
  };
  generateAuthCode = {
    /**
     * No description
     *
     * @tags generate_auth_code
     * @name GenerateAuthCodeCreate
     * @request POST:/generate_auth_code/
     * @secure
     */
    generateAuthCodeCreate: (params: RequestParams = {}) =>
      this.request<AuthorizationCode, any>({
        path: `/generate_auth_code/`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),
  };
  lastSearchbar = {
    /**
     * @description Handle chat messages and stream responses
     *
     * @tags last-searchbar
     * @name LastSearchbarChatCreate
     * @request POST:/last-searchbar/chat/
     * @secure
     */
    lastSearchbarChatCreate: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/last-searchbar/chat/`,
        method: "POST",
        secure: true,
        ...params,
      }),

    /**
     * @description Get all conversations
     *
     * @tags last-searchbar
     * @name LastSearchbarConversationsRetrieve
     * @request GET:/last-searchbar/conversations/
     * @secure
     */
    lastSearchbarConversationsRetrieve: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/last-searchbar/conversations/`,
        method: "GET",
        secure: true,
        ...params,
      }),

    /**
     * @description Get a specific conversation
     *
     * @tags last-searchbar
     * @name LastSearchbarConversationsRetrieve2
     * @request GET:/last-searchbar/conversations/{conversation_id}/
     * @secure
     */
    lastSearchbarConversationsRetrieve2: (conversationId: number, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/last-searchbar/conversations/${conversationId}/`,
        method: "GET",
        secure: true,
        ...params,
      }),

    /**
     * @description Search endpoint that returns matching results based on the query
     *
     * @tags last-searchbar
     * @name LastSearchbarSearchCreate
     * @request POST:/last-searchbar/search/
     * @secure
     */
    lastSearchbarSearchCreate: (data: SearchRequest, params: RequestParams = {}) =>
      this.request<SearchResult[], any>({
        path: `/last-searchbar/search/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  llmFunctionCaller = {
    /**
     * No description
     *
     * @tags llm_function_caller
     * @name LlmFunctionCallerCreate
     * @request POST:/llm_function_caller/
     * @secure
     */
    llmFunctionCallerCreate: (data: LLMFunctionCallerRequest, params: RequestParams = {}) =>
      this.request<LLMFunctionCallerResponse, any>({
        path: `/llm_function_caller/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  login = {
    /**
     * No description
     *
     * @tags login
     * @name LoginCreate
     * @request POST:/login/
     * @secure
     */
    loginCreate: (data: Login, params: RequestParams = {}) =>
      this.request<void, void>({
        path: `/login/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),
  };
  logout = {
    /**
     * No description
     *
     * @tags logout
     * @name LogoutCreate
     * @request POST:/logout/
     * @secure
     */
    logoutCreate: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/logout/`,
        method: "POST",
        secure: true,
        ...params,
      }),
  };
  mlServices = {
    /**
     * @description Process a query against dimensions and return an array of float weights
     *
     * @tags ml_services
     * @name MlServicesWeighterCreate
     * @request POST:/ml_services/weighter/
     * @secure
     */
    mlServicesWeighterCreate: (
      data: {
        /** List of dimension strings */
        dimensions: string[];
        /** The input query to process */
        query: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          /** Array of float values */
          weights?: number[];
        },
        {
          error?: string;
        }
      >({
        path: `/ml_services/weighter/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  passwordReset = {
    /**
     * No description
     *
     * @tags password_reset
     * @name PasswordResetCreate
     * @request POST:/password_reset/{token}/
     * @secure
     */
    passwordResetCreate: (token: string, data: PasswordReset, params: RequestParams = {}) =>
      this.request<any, any>({
        path: `/password_reset/${token}/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  passwordResetEmail = {
    /**
     * No description
     *
     * @tags password_reset_email
     * @name PasswordResetEmailCreate
     * @request POST:/password_reset_email/
     * @secure
     */
    passwordResetEmailCreate: (data: PasswordResetEmail, params: RequestParams = {}) =>
      this.request<any, void>({
        path: `/password_reset_email/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  rhea = {
    /**
     * @description Get user action settings including enabled, owned and default actions
     *
     * @tags rhea
     * @name RheaApiActionSettingsRetrieve
     * @request GET:/rhea/api/action-settings/
     * @secure
     */
    rheaApiActionSettingsRetrieve: (params: RequestParams = {}) =>
      this.request<UserActionSettingsResponse, any>({
        path: `/rhea/api/action-settings/`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Add a query result match
     *
     * @tags rhea
     * @name RheaApiAddQueryResultMatchCreate
     * @request POST:/rhea/api/add-query-result-match/
     * @secure
     */
    rheaApiAddQueryResultMatchCreate: (data: QueryResultMatch, params: RequestParams = {}) =>
      this.request<Record<string, any>, any>({
        path: `/rhea/api/add-query-result-match/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Chat with the AI
     *
     * @tags rhea
     * @name RheaApiChatCreate
     * @request POST:/rhea/api/chat/
     * @secure
     */
    rheaApiChatCreate: (data: ChatRequest, params: RequestParams = {}) =>
      this.request<ChatResponse, any>({
        path: `/rhea/api/chat/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Get a specific conversation
     *
     * @tags rhea
     * @name RheaApiConversationRetrieve
     * @request GET:/rhea/api/conversation/{conversation_id}/
     * @secure
     */
    rheaApiConversationRetrieve: (conversationId: number, params: RequestParams = {}) =>
      this.request<Conversation, any>({
        path: `/rhea/api/conversation/${conversationId}/`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Get all conversations
     *
     * @tags rhea
     * @name RheaApiConversationsList
     * @request GET:/rhea/api/conversations/
     * @secure
     */
    rheaApiConversationsList: (params: RequestParams = {}) =>
      this.request<Conversation[], any>({
        path: `/rhea/api/conversations/`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags rhea
     * @name RheaApiCreateActionCreate
     * @request POST:/rhea/api/create-action/
     * @secure
     */
    rheaApiCreateActionCreate: (data: Action, params: RequestParams = {}) =>
      this.request<Action, CreateActionError>({
        path: `/rhea/api/create-action/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Search for actions
     *
     * @tags rhea
     * @name RheaApiDomainSearchCreate
     * @request POST:/rhea/api/domain-search/
     * @secure
     */
    rheaApiDomainSearchCreate: (data: DomainSearchRequest, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/rhea/api/domain-search/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Edit an existing action
     *
     * @tags rhea
     * @name RheaApiEditActionUpdate
     * @request PUT:/rhea/api/edit-action/{action_id}/
     * @secure
     */
    rheaApiEditActionUpdate: (actionId: number, data: Action, params: RequestParams = {}) =>
      this.request<Action, EditActionError | EditActionNotFound>({
        path: `/rhea/api/edit-action/${actionId}/`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Search for actions
     *
     * @tags rhea
     * @name RheaApiExternalSearchCreate
     * @request POST:/rhea/api/external-search/
     * @secure
     */
    rheaApiExternalSearchCreate: (data: SearchRequest, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/rhea/api/external-search/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Get all public actions
     *
     * @tags rhea
     * @name RheaApiPublicActionsList
     * @request GET:/rhea/api/public-actions/
     * @secure
     */
    rheaApiPublicActionsList: (params: RequestParams = {}) =>
      this.request<Action[], any>({
        path: `/rhea/api/public-actions/`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags rhea
     * @name RheaApiPublicDomainsRetrieve
     * @request GET:/rhea/api/public-domains/
     * @secure
     */
    rheaApiPublicDomainsRetrieve: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/rhea/api/public-domains/`,
        method: "GET",
        secure: true,
        ...params,
      }),

    /**
     * @description Get available databases for the authenticated user
     *
     * @tags rhea
     * @name RheaApiRheaAccountDatabasesRetrieve
     * @request GET:/rhea/api/rhea-account/databases/
     * @secure
     */
    rheaApiRheaAccountDatabasesRetrieve: (params: RequestParams = {}) =>
      this.request<DatabaseList, any>({
        path: `/rhea/api/rhea-account/databases/`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description This endpoint exists only to ensure certain serializers are included in the OpenAPI schema.
     *
     * @tags rhea
     * @name RheaApiSchemaReferencesList
     * @request GET:/rhea/api/schema-references/
     * @secure
     */
    rheaApiSchemaReferencesList: (params: RequestParams = {}) =>
      this.request<ActionResult[], any>({
        path: `/rhea/api/schema-references/`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Search for actions
     *
     * @tags rhea
     * @name RheaApiSimpleSearchCreate
     * @request POST:/rhea/api/simple-search/
     * @secure
     */
    rheaApiSimpleSearchCreate: (data: SearchRequest, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/rhea/api/simple-search/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Toggle an action for the user
     *
     * @tags rhea
     * @name RheaApiToggleActionCreate
     * @request POST:/rhea/api/toggle-action/
     * @secure
     */
    rheaApiToggleActionCreate: (data: ToggleActionRequest, params: RequestParams = {}) =>
      this.request<UserAction[], any>({
        path: `/rhea/api/toggle-action/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  signup = {
    /**
     * No description
     *
     * @tags signup
     * @name SignupCreate
     * @request POST:/signup/
     * @secure
     */
    signupCreate: (data: UserSignup, params: RequestParams = {}) =>
      this.request<void, SignupError>({
        path: `/signup/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),
  };
  stripeCheckout = {
    /**
     * No description
     *
     * @tags stripe_checkout
     * @name StripeCheckoutCreate
     * @request POST:/stripe_checkout/
     * @secure
     */
    stripeCheckoutCreate: (data: StripeCheckout, params: RequestParams = {}) =>
      this.request<StripeCheckoutResponse, any>({
        path: `/stripe_checkout/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  stripePortal = {
    /**
     * No description
     *
     * @tags stripe_portal
     * @name StripePortalCreate
     * @request POST:/stripe_portal/
     * @secure
     */
    stripePortalCreate: (params: RequestParams = {}) =>
      this.request<StripePortal, any>({
        path: `/stripe_portal/`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),
  };
  stripeWebhook = {
    /**
     * No description
     *
     * @tags stripe_webhook
     * @name StripeWebhookCreate
     * @request POST:/stripe_webhook/
     * @secure
     */
    stripeWebhookCreate: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/stripe_webhook/`,
        method: "POST",
        secure: true,
        ...params,
      }),
  };
  testsuite = {
    /**
     * No description
     *
     * @tags testsuite
     * @name TestsuiteApiCancelLlmJobCreate
     * @request POST:/testsuite/api/cancel-llm-job/
     * @secure
     */
    testsuiteApiCancelLlmJobCreate: (data: CancelLLMJob, params: RequestParams = {}) =>
      this.request<LLMJob, any>({
        path: `/testsuite/api/cancel-llm-job/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags testsuite
     * @name TestsuiteApiCancelLlmJobFormattedCreate
     * @request POST:/testsuite/api/cancel-llm-job{format}
     * @secure
     */
    testsuiteApiCancelLlmJobFormattedCreate: (format: ".json", data: CancelLLMJob, params: RequestParams = {}) =>
      this.request<LLMJob, any>({
        path: `/testsuite/api/cancel-llm-job${format}`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags testsuite
     * @name TestsuiteApiCancelOperationCreate
     * @request POST:/testsuite/api/cancel-operation/{operation_id}/
     * @secure
     */
    testsuiteApiCancelOperationCreate: (operationId: string, data: FullOperation, params: RequestParams = {}) =>
      this.request<FullOperation, any>({
        path: `/testsuite/api/cancel-operation/${operationId}/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags testsuite
     * @name TestsuiteApiCancelOperationFormattedCreate
     * @request POST:/testsuite/api/cancel-operation/{operation_id}{format}
     * @secure
     */
    testsuiteApiCancelOperationFormattedCreate: (
      format: ".json",
      operationId: string,
      data: FullOperation,
      params: RequestParams = {},
    ) =>
      this.request<FullOperation, any>({
        path: `/testsuite/api/cancel-operation/${operationId}${format}`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags testsuite
     * @name TestsuiteApiCloneOperationCreate
     * @request POST:/testsuite/api/clone-operation/{operation_id}/
     * @secure
     */
    testsuiteApiCloneOperationCreate: (operationId: string, data: FullOperation, params: RequestParams = {}) =>
      this.request<FullOperation, any>({
        path: `/testsuite/api/clone-operation/${operationId}/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags testsuite
     * @name TestsuiteApiCloneOperationFormattedCreate
     * @request POST:/testsuite/api/clone-operation/{operation_id}{format}
     * @secure
     */
    testsuiteApiCloneOperationFormattedCreate: (
      format: ".json",
      operationId: string,
      data: FullOperation,
      params: RequestParams = {},
    ) =>
      this.request<FullOperation, any>({
        path: `/testsuite/api/clone-operation/${operationId}${format}`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags testsuite
     * @name TestsuiteApiCreateAnalysisCreate
     * @request POST:/testsuite/api/create-analysis/
     * @secure
     */
    testsuiteApiCreateAnalysisCreate: (
      data: {
        name: string;
        description: string;
        analysis_class: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<FullAnalysis, any>({
        path: `/testsuite/api/create-analysis/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.FormData,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags testsuite
     * @name TestsuiteApiCreateAnalysisFormattedCreate
     * @request POST:/testsuite/api/create-analysis{format}
     * @secure
     */
    testsuiteApiCreateAnalysisFormattedCreate: (
      format: ".json",
      data: {
        name: string;
        description: string;
        analysis_class: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<FullAnalysis, any>({
        path: `/testsuite/api/create-analysis${format}`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.FormData,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags testsuite
     * @name TestsuiteApiCreateDatabaseCreate
     * @request POST:/testsuite/api/create-database/{dataset_id}/
     * @secure
     */
    testsuiteApiCreateDatabaseCreate: (datasetId: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/testsuite/api/create-database/${datasetId}/`,
        method: "POST",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags testsuite
     * @name TestsuiteApiCreateDatabaseFormattedCreate
     * @request POST:/testsuite/api/create-database/{dataset_id}{format}
     * @secure
     */
    testsuiteApiCreateDatabaseFormattedCreate: (datasetId: string, format: ".json", params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/testsuite/api/create-database/${datasetId}${format}`,
        method: "POST",
        secure: true,
        ...params,
      }),

    /**
     * @description Create a new dataset with the provided details.
     *
     * @tags testsuite
     * @name TestsuiteApiCreateDatasetCreate
     * @request POST:/testsuite/api/create-dataset/
     * @secure
     */
    testsuiteApiCreateDatasetCreate: (
      data: {
        name: string;
        description?: string;
        data_type: string;
        data_source: string;
        meta_data?: object;
        files: File[];
      },
      params: RequestParams = {},
    ) =>
      this.request<Dataset, any>({
        path: `/testsuite/api/create-dataset/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.FormData,
        format: "json",
        ...params,
      }),

    /**
     * @description Create a new dataset with the provided details.
     *
     * @tags testsuite
     * @name TestsuiteApiCreateDatasetFormattedCreate
     * @request POST:/testsuite/api/create-dataset{format}
     * @secure
     */
    testsuiteApiCreateDatasetFormattedCreate: (
      format: ".json",
      data: {
        name: string;
        description?: string;
        data_type: string;
        data_source: string;
        meta_data?: object;
        files: File[];
      },
      params: RequestParams = {},
    ) =>
      this.request<Dataset, any>({
        path: `/testsuite/api/create-dataset${format}`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.FormData,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags testsuite
     * @name TestsuiteApiCreateDatumCreate
     * @request POST:/testsuite/api/create-datum/
     * @secure
     */
    testsuiteApiCreateDatumCreate: (
      data: {
        dataset_id: string;
        content: object;
      },
      params: RequestParams = {},
    ) =>
      this.request<Datum, any>({
        path: `/testsuite/api/create-datum/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags testsuite
     * @name TestsuiteApiCreateDatumFormattedCreate
     * @request POST:/testsuite/api/create-datum{format}
     * @secure
     */
    testsuiteApiCreateDatumFormattedCreate: (
      format: ".json",
      data: {
        dataset_id: string;
        content: object;
      },
      params: RequestParams = {},
    ) =>
      this.request<Datum, any>({
        path: `/testsuite/api/create-datum${format}`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Create a new experiment with the provided details.
     *
     * @tags testsuite
     * @name TestsuiteApiCreateExperimentCreate
     * @request POST:/testsuite/api/create-experiment/
     * @secure
     */
    testsuiteApiCreateExperimentCreate: (
      data: {
        name: string;
        description: string;
        experiment_class: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<FullExperiment, any>({
        path: `/testsuite/api/create-experiment/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.FormData,
        format: "json",
        ...params,
      }),

    /**
     * @description Create a new experiment with the provided details.
     *
     * @tags testsuite
     * @name TestsuiteApiCreateExperimentFormattedCreate
     * @request POST:/testsuite/api/create-experiment{format}
     * @secure
     */
    testsuiteApiCreateExperimentFormattedCreate: (
      format: ".json",
      data: {
        name: string;
        description: string;
        experiment_class: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<FullExperiment, any>({
        path: `/testsuite/api/create-experiment${format}`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.FormData,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags testsuite
     * @name TestsuiteApiCreateExperimentFromTemplateCreate
     * @request POST:/testsuite/api/create-experiment-from-template/{template_name}/
     * @secure
     */
    testsuiteApiCreateExperimentFromTemplateCreate: (
      templateName: string,
      data: {
        search_dataset: number;
        config_dataset: number;
        model: string;
        synthetic_dataset_size: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<CreateExperimentFromTemplateResponse, any>({
        path: `/testsuite/api/create-experiment-from-template/${templateName}/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.FormData,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags testsuite
     * @name TestsuiteApiCreateExperimentFromTemplateFormattedCreate
     * @request POST:/testsuite/api/create-experiment-from-template/{template_name}{format}
     * @secure
     */
    testsuiteApiCreateExperimentFromTemplateFormattedCreate: (
      format: ".json",
      templateName: string,
      data: {
        search_dataset: number;
        config_dataset: number;
        model: string;
        synthetic_dataset_size: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<CreateExperimentFromTemplateResponse, any>({
        path: `/testsuite/api/create-experiment-from-template/${templateName}${format}`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.FormData,
        format: "json",
        ...params,
      }),

    /**
     * @description Create a new operation with the provided details.
     *
     * @tags testsuite
     * @name TestsuiteApiCreateOperationCreate
     * @request POST:/testsuite/api/create-operation/
     * @secure
     */
    testsuiteApiCreateOperationCreate: (
      data: {
        name: string;
        description: string;
        execution_class: string;
        experiment: number;
        model?: string;
        experiment_order: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<FullOperation, any>({
        path: `/testsuite/api/create-operation/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.FormData,
        format: "json",
        ...params,
      }),

    /**
     * @description Create a new operation with the provided details.
     *
     * @tags testsuite
     * @name TestsuiteApiCreateOperationFormattedCreate
     * @request POST:/testsuite/api/create-operation{format}
     * @secure
     */
    testsuiteApiCreateOperationFormattedCreate: (
      format: ".json",
      data: {
        name: string;
        description: string;
        execution_class: string;
        experiment: number;
        model?: string;
        experiment_order: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<FullOperation, any>({
        path: `/testsuite/api/create-operation${format}`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.FormData,
        format: "json",
        ...params,
      }),

    /**
     * @description Create a new prompt template with the provided details.
     *
     * @tags testsuite
     * @name TestsuiteApiCreatePromptTemplateCreate
     * @request POST:/testsuite/api/create-prompt-template/
     * @secure
     */
    testsuiteApiCreatePromptTemplateCreate: (
      data: {
        name: string;
        description: string;
        type: string;
        output_type?: string;
        prompt: string;
        dataset?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<FullPromptTemplate, any>({
        path: `/testsuite/api/create-prompt-template/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.FormData,
        format: "json",
        ...params,
      }),

    /**
     * @description Create a new prompt template with the provided details.
     *
     * @tags testsuite
     * @name TestsuiteApiCreatePromptTemplateFormattedCreate
     * @request POST:/testsuite/api/create-prompt-template{format}
     * @secure
     */
    testsuiteApiCreatePromptTemplateFormattedCreate: (
      format: ".json",
      data: {
        name: string;
        description: string;
        type: string;
        output_type?: string;
        prompt: string;
        dataset?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<FullPromptTemplate, any>({
        path: `/testsuite/api/create-prompt-template${format}`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.FormData,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags testsuite
     * @name TestsuiteApiCreateStudyCreate
     * @request POST:/testsuite/api/create-study/
     * @secure
     */
    testsuiteApiCreateStudyCreate: (
      data: {
        name: string;
        description: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<FullStudy, any>({
        path: `/testsuite/api/create-study/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.FormData,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags testsuite
     * @name TestsuiteApiCreateStudyFormattedCreate
     * @request POST:/testsuite/api/create-study{format}
     * @secure
     */
    testsuiteApiCreateStudyFormattedCreate: (
      format: ".json",
      data: {
        name: string;
        description: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<FullStudy, any>({
        path: `/testsuite/api/create-study${format}`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.FormData,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags testsuite
     * @name TestsuiteApiCreateStudyBlockCreate
     * @request POST:/testsuite/api/create-study-block/
     * @secure
     */
    testsuiteApiCreateStudyBlockCreate: (
      data: {
        study: number;
        block_type: "TEXT" | "ANALYSIS" | "BENCHMARK";
        order: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<FullStudyBlock, any>({
        path: `/testsuite/api/create-study-block/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.FormData,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags testsuite
     * @name TestsuiteApiCreateStudyBlockFormattedCreate
     * @request POST:/testsuite/api/create-study-block{format}
     * @secure
     */
    testsuiteApiCreateStudyBlockFormattedCreate: (
      format: ".json",
      data: {
        study: number;
        block_type: "TEXT" | "ANALYSIS" | "BENCHMARK";
        order: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<FullStudyBlock, any>({
        path: `/testsuite/api/create-study-block${format}`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.FormData,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags testsuite
     * @name TestsuiteApiCreateSubsetCreate
     * @request POST:/testsuite/api/create-subset/{dataset_id}/
     * @secure
     */
    testsuiteApiCreateSubsetCreate: (datasetId: string, data: SubsetCreation, params: RequestParams = {}) =>
      this.request<SubsetCreation, any>({
        path: `/testsuite/api/create-subset/${datasetId}/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags testsuite
     * @name TestsuiteApiCreateSubsetFormattedCreate
     * @request POST:/testsuite/api/create-subset/{dataset_id}{format}
     * @secure
     */
    testsuiteApiCreateSubsetFormattedCreate: (
      datasetId: string,
      format: ".json",
      data: SubsetCreation,
      params: RequestParams = {},
    ) =>
      this.request<SubsetCreation, any>({
        path: `/testsuite/api/create-subset/${datasetId}${format}`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags testsuite
     * @name TestsuiteApiDeleteAnalysisDestroy
     * @request DELETE:/testsuite/api/delete-analysis/{analysis_id}/
     * @secure
     */
    testsuiteApiDeleteAnalysisDestroy: (analysisId: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/testsuite/api/delete-analysis/${analysisId}/`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags testsuite
     * @name TestsuiteApiDeleteAnalysisFormattedDestroy
     * @request DELETE:/testsuite/api/delete-analysis/{analysis_id}{format}
     * @secure
     */
    testsuiteApiDeleteAnalysisFormattedDestroy: (analysisId: string, format: ".json", params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/testsuite/api/delete-analysis/${analysisId}${format}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags testsuite
     * @name TestsuiteApiDeleteDatasetDestroy
     * @request DELETE:/testsuite/api/delete-dataset/{dataset_id}/
     * @secure
     */
    testsuiteApiDeleteDatasetDestroy: (datasetId: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/testsuite/api/delete-dataset/${datasetId}/`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags testsuite
     * @name TestsuiteApiDeleteDatasetFormattedDestroy
     * @request DELETE:/testsuite/api/delete-dataset/{dataset_id}{format}
     * @secure
     */
    testsuiteApiDeleteDatasetFormattedDestroy: (datasetId: string, format: ".json", params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/testsuite/api/delete-dataset/${datasetId}${format}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags testsuite
     * @name TestsuiteApiDeleteDatumDestroy
     * @request DELETE:/testsuite/api/delete-datum/{datum_id}/
     * @secure
     */
    testsuiteApiDeleteDatumDestroy: (datumId: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/testsuite/api/delete-datum/${datumId}/`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags testsuite
     * @name TestsuiteApiDeleteDatumFormattedDestroy
     * @request DELETE:/testsuite/api/delete-datum/{datum_id}{format}
     * @secure
     */
    testsuiteApiDeleteDatumFormattedDestroy: (datumId: string, format: ".json", params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/testsuite/api/delete-datum/${datumId}${format}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags testsuite
     * @name TestsuiteApiDeleteExperimentDestroy
     * @request DELETE:/testsuite/api/delete-experiment/{experiment_id}/
     * @secure
     */
    testsuiteApiDeleteExperimentDestroy: (experimentId: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/testsuite/api/delete-experiment/${experimentId}/`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags testsuite
     * @name TestsuiteApiDeleteExperimentFormattedDestroy
     * @request DELETE:/testsuite/api/delete-experiment/{experiment_id}{format}
     * @secure
     */
    testsuiteApiDeleteExperimentFormattedDestroy: (experimentId: string, format: ".json", params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/testsuite/api/delete-experiment/${experimentId}${format}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags testsuite
     * @name TestsuiteApiDeleteOperationDestroy
     * @request DELETE:/testsuite/api/delete-operation/{operation_id}/
     * @secure
     */
    testsuiteApiDeleteOperationDestroy: (operationId: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/testsuite/api/delete-operation/${operationId}/`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags testsuite
     * @name TestsuiteApiDeleteOperationFormattedDestroy
     * @request DELETE:/testsuite/api/delete-operation/{operation_id}{format}
     * @secure
     */
    testsuiteApiDeleteOperationFormattedDestroy: (format: ".json", operationId: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/testsuite/api/delete-operation/${operationId}${format}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags testsuite
     * @name TestsuiteApiDeletePromptTemplateDestroy
     * @request DELETE:/testsuite/api/delete-prompt-template/{prompt_template_id}/
     * @secure
     */
    testsuiteApiDeletePromptTemplateDestroy: (promptTemplateId: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/testsuite/api/delete-prompt-template/${promptTemplateId}/`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags testsuite
     * @name TestsuiteApiDeletePromptTemplateFormattedDestroy
     * @request DELETE:/testsuite/api/delete-prompt-template/{prompt_template_id}{format}
     * @secure
     */
    testsuiteApiDeletePromptTemplateFormattedDestroy: (
      format: ".json",
      promptTemplateId: string,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/testsuite/api/delete-prompt-template/${promptTemplateId}${format}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags testsuite
     * @name TestsuiteApiDeleteStudyBlockDestroy
     * @request DELETE:/testsuite/api/delete-study-block/{study_block_id}/
     * @secure
     */
    testsuiteApiDeleteStudyBlockDestroy: (studyBlockId: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/testsuite/api/delete-study-block/${studyBlockId}/`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags testsuite
     * @name TestsuiteApiDeleteStudyBlockFormattedDestroy
     * @request DELETE:/testsuite/api/delete-study-block/{study_block_id}{format}
     * @secure
     */
    testsuiteApiDeleteStudyBlockFormattedDestroy: (format: ".json", studyBlockId: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/testsuite/api/delete-study-block/${studyBlockId}${format}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * @description Duplicate a dataset with the provided details.
     *
     * @tags testsuite
     * @name TestsuiteApiDuplicateDatasetCreate
     * @request POST:/testsuite/api/duplicate-dataset/{dataset_id}/
     * @secure
     */
    testsuiteApiDuplicateDatasetCreate: (
      datasetId: string,
      data: {
        name?: string;
        description?: string;
        columns?: string[];
      },
      params: RequestParams = {},
    ) =>
      this.request<Dataset, any>({
        path: `/testsuite/api/duplicate-dataset/${datasetId}/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Duplicate a dataset with the provided details.
     *
     * @tags testsuite
     * @name TestsuiteApiDuplicateDatasetFormattedCreate
     * @request POST:/testsuite/api/duplicate-dataset/{dataset_id}{format}
     * @secure
     */
    testsuiteApiDuplicateDatasetFormattedCreate: (
      datasetId: string,
      format: ".json",
      data: {
        name?: string;
        description?: string;
        columns?: string[];
      },
      params: RequestParams = {},
    ) =>
      this.request<Dataset, any>({
        path: `/testsuite/api/duplicate-dataset/${datasetId}${format}`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags testsuite
     * @name TestsuiteApiExportDatasetRetrieve
     * @request GET:/testsuite/api/export-dataset/{dataset_id}/
     * @secure
     */
    testsuiteApiExportDatasetRetrieve: (datasetId: string, params: RequestParams = {}) =>
      this.request<ExportDataset, any>({
        path: `/testsuite/api/export-dataset/${datasetId}/`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags testsuite
     * @name TestsuiteApiExportDatasetFormattedRetrieve
     * @request GET:/testsuite/api/export-dataset/{dataset_id}{format}
     * @secure
     */
    testsuiteApiExportDatasetFormattedRetrieve: (datasetId: string, format: ".json", params: RequestParams = {}) =>
      this.request<ExportDataset, any>({
        path: `/testsuite/api/export-dataset/${datasetId}${format}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags testsuite
     * @name TestsuiteApiExportExperimentRetrieve
     * @request GET:/testsuite/api/export-experiment/{experiment_id}/
     * @secure
     */
    testsuiteApiExportExperimentRetrieve: (experimentId: string, params: RequestParams = {}) =>
      this.request<ExportExperiment, any>({
        path: `/testsuite/api/export-experiment/${experimentId}/`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags testsuite
     * @name TestsuiteApiExportExperimentFormattedRetrieve
     * @request GET:/testsuite/api/export-experiment/{experiment_id}{format}
     * @secure
     */
    testsuiteApiExportExperimentFormattedRetrieve: (
      experimentId: string,
      format: ".json",
      params: RequestParams = {},
    ) =>
      this.request<ExportExperiment, any>({
        path: `/testsuite/api/export-experiment/${experimentId}${format}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags testsuite
     * @name TestsuiteApiGetAnalysisRegistryRetrieve
     * @request GET:/testsuite/api/get-analysis-registry/
     * @secure
     */
    testsuiteApiGetAnalysisRegistryRetrieve: (params: RequestParams = {}) =>
      this.request<string[], any>({
        path: `/testsuite/api/get-analysis-registry/`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags testsuite
     * @name TestsuiteApiGetAnalysisRegistryFormattedRetrieve
     * @request GET:/testsuite/api/get-analysis-registry{format}
     * @secure
     */
    testsuiteApiGetAnalysisRegistryFormattedRetrieve: (format: ".json", params: RequestParams = {}) =>
      this.request<string[], any>({
        path: `/testsuite/api/get-analysis-registry${format}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags testsuite
     * @name TestsuiteApiGetAnalysisRetrieve
     * @request GET:/testsuite/api/get-analysis/{analysis_id}/
     * @secure
     */
    testsuiteApiGetAnalysisRetrieve: (analysisId: string, params: RequestParams = {}) =>
      this.request<FullAnalysis, any>({
        path: `/testsuite/api/get-analysis/${analysisId}/`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags testsuite
     * @name TestsuiteApiGetAnalysisFormattedRetrieve
     * @request GET:/testsuite/api/get-analysis/{analysis_id}{format}
     * @secure
     */
    testsuiteApiGetAnalysisFormattedRetrieve: (analysisId: string, format: ".json", params: RequestParams = {}) =>
      this.request<FullAnalysis, any>({
        path: `/testsuite/api/get-analysis/${analysisId}${format}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags testsuite
     * @name TestsuiteApiGetCopilotSuggestionCreate
     * @request POST:/testsuite/api/get-copilot-suggestion/
     * @secure
     */
    testsuiteApiGetCopilotSuggestionCreate: (data: CopilotSuggestion, params: RequestParams = {}) =>
      this.request<Record<string, any>, any>({
        path: `/testsuite/api/get-copilot-suggestion/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags testsuite
     * @name TestsuiteApiGetCopilotSuggestionFormattedCreate
     * @request POST:/testsuite/api/get-copilot-suggestion{format}
     * @secure
     */
    testsuiteApiGetCopilotSuggestionFormattedCreate: (
      format: ".json",
      data: CopilotSuggestion,
      params: RequestParams = {},
    ) =>
      this.request<Record<string, any>, any>({
        path: `/testsuite/api/get-copilot-suggestion${format}`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags testsuite
     * @name TestsuiteApiGetDatasetDatumRetrieve
     * @request GET:/testsuite/api/get-dataset-datum/{dataset_id}/
     * @secure
     */
    testsuiteApiGetDatasetDatumRetrieve: (datasetId: string, params: RequestParams = {}) =>
      this.request<Datum, any>({
        path: `/testsuite/api/get-dataset-datum/${datasetId}/`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags testsuite
     * @name TestsuiteApiGetDatasetDatumFormattedRetrieve
     * @request GET:/testsuite/api/get-dataset-datum/{dataset_id}{format}
     * @secure
     */
    testsuiteApiGetDatasetDatumFormattedRetrieve: (datasetId: string, format: ".json", params: RequestParams = {}) =>
      this.request<Datum, any>({
        path: `/testsuite/api/get-dataset-datum/${datasetId}${format}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags testsuite
     * @name TestsuiteApiGetDatasetSubsetsRetrieve
     * @request GET:/testsuite/api/get-dataset-subsets/{dataset_id}/
     * @secure
     */
    testsuiteApiGetDatasetSubsetsRetrieve: (datasetId: string, params: RequestParams = {}) =>
      this.request<Dataset[], any>({
        path: `/testsuite/api/get-dataset-subsets/${datasetId}/`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags testsuite
     * @name TestsuiteApiGetDatasetSubsetsFormattedRetrieve
     * @request GET:/testsuite/api/get-dataset-subsets/{dataset_id}{format}
     * @secure
     */
    testsuiteApiGetDatasetSubsetsFormattedRetrieve: (datasetId: string, format: ".json", params: RequestParams = {}) =>
      this.request<Dataset[], any>({
        path: `/testsuite/api/get-dataset-subsets/${datasetId}${format}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags testsuite
     * @name TestsuiteApiGetDatasetRetrieve
     * @request GET:/testsuite/api/get-dataset/{dataset_id}/
     * @secure
     */
    testsuiteApiGetDatasetRetrieve: (datasetId: string, params: RequestParams = {}) =>
      this.request<Dataset, any>({
        path: `/testsuite/api/get-dataset/${datasetId}/`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags testsuite
     * @name TestsuiteApiGetDatasetFormattedRetrieve
     * @request GET:/testsuite/api/get-dataset/{dataset_id}{format}
     * @secure
     */
    testsuiteApiGetDatasetFormattedRetrieve: (datasetId: string, format: ".json", params: RequestParams = {}) =>
      this.request<Dataset, any>({
        path: `/testsuite/api/get-dataset/${datasetId}${format}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags testsuite
     * @name TestsuiteApiGetDatumRetrieve
     * @request GET:/testsuite/api/get-datum/{datum_id}/
     * @secure
     */
    testsuiteApiGetDatumRetrieve: (datumId: string, params: RequestParams = {}) =>
      this.request<Datum, any>({
        path: `/testsuite/api/get-datum/${datumId}/`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags testsuite
     * @name TestsuiteApiGetDatumFormattedRetrieve
     * @request GET:/testsuite/api/get-datum/{datum_id}{format}
     * @secure
     */
    testsuiteApiGetDatumFormattedRetrieve: (datumId: string, format: ".json", params: RequestParams = {}) =>
      this.request<Datum, any>({
        path: `/testsuite/api/get-datum/${datumId}${format}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags testsuite
     * @name TestsuiteApiGetExecutionRegistryRetrieve
     * @request GET:/testsuite/api/get-execution-registry/
     * @secure
     */
    testsuiteApiGetExecutionRegistryRetrieve: (params: RequestParams = {}) =>
      this.request<string[], any>({
        path: `/testsuite/api/get-execution-registry/`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags testsuite
     * @name TestsuiteApiGetExecutionRegistryFormattedRetrieve
     * @request GET:/testsuite/api/get-execution-registry{format}
     * @secure
     */
    testsuiteApiGetExecutionRegistryFormattedRetrieve: (format: ".json", params: RequestParams = {}) =>
      this.request<string[], any>({
        path: `/testsuite/api/get-execution-registry${format}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags testsuite
     * @name TestsuiteApiGetExperimentRetrieve
     * @request GET:/testsuite/api/get-experiment/{experiment_id}/
     * @secure
     */
    testsuiteApiGetExperimentRetrieve: (experimentId: string, params: RequestParams = {}) =>
      this.request<Experiment, any>({
        path: `/testsuite/api/get-experiment/${experimentId}/`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags testsuite
     * @name TestsuiteApiGetExperimentFormattedRetrieve
     * @request GET:/testsuite/api/get-experiment/{experiment_id}{format}
     * @secure
     */
    testsuiteApiGetExperimentFormattedRetrieve: (experimentId: string, format: ".json", params: RequestParams = {}) =>
      this.request<Experiment, any>({
        path: `/testsuite/api/get-experiment/${experimentId}${format}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags testsuite
     * @name TestsuiteApiGetFullExperimentRetrieve
     * @request GET:/testsuite/api/get-full-experiment/{experiment_id}/
     * @secure
     */
    testsuiteApiGetFullExperimentRetrieve: (experimentId: string, params: RequestParams = {}) =>
      this.request<FullExperiment, any>({
        path: `/testsuite/api/get-full-experiment/${experimentId}/`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags testsuite
     * @name TestsuiteApiGetFullExperimentFormattedRetrieve
     * @request GET:/testsuite/api/get-full-experiment/{experiment_id}{format}
     * @secure
     */
    testsuiteApiGetFullExperimentFormattedRetrieve: (
      experimentId: string,
      format: ".json",
      params: RequestParams = {},
    ) =>
      this.request<FullExperiment, any>({
        path: `/testsuite/api/get-full-experiment/${experimentId}${format}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags testsuite
     * @name TestsuiteApiGetFullOperationRetrieve
     * @request GET:/testsuite/api/get-full-operation/{operation_id}/
     * @secure
     */
    testsuiteApiGetFullOperationRetrieve: (operationId: string, params: RequestParams = {}) =>
      this.request<FullOperation, any>({
        path: `/testsuite/api/get-full-operation/${operationId}/`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags testsuite
     * @name TestsuiteApiGetFullOperationFormattedRetrieve
     * @request GET:/testsuite/api/get-full-operation/{operation_id}{format}
     * @secure
     */
    testsuiteApiGetFullOperationFormattedRetrieve: (format: ".json", operationId: string, params: RequestParams = {}) =>
      this.request<FullOperation, any>({
        path: `/testsuite/api/get-full-operation/${operationId}${format}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags testsuite
     * @name TestsuiteApiGetLlmJobRetrieve
     * @request GET:/testsuite/api/get-llm-job/{llm_job_id}/
     * @secure
     */
    testsuiteApiGetLlmJobRetrieve: (llmJobId: string, params: RequestParams = {}) =>
      this.request<LLMJob, any>({
        path: `/testsuite/api/get-llm-job/${llmJobId}/`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags testsuite
     * @name TestsuiteApiGetLlmJobFormattedRetrieve
     * @request GET:/testsuite/api/get-llm-job/{llm_job_id}{format}
     * @secure
     */
    testsuiteApiGetLlmJobFormattedRetrieve: (format: ".json", llmJobId: string, params: RequestParams = {}) =>
      this.request<LLMJob, any>({
        path: `/testsuite/api/get-llm-job/${llmJobId}${format}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags testsuite
     * @name TestsuiteApiGetOperationLlmJobsRetrieve
     * @request GET:/testsuite/api/get-operation-llm-jobs/{operation_id}/
     * @secure
     */
    testsuiteApiGetOperationLlmJobsRetrieve: (operationId: string, params: RequestParams = {}) =>
      this.request<LLMJob[], any>({
        path: `/testsuite/api/get-operation-llm-jobs/${operationId}/`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags testsuite
     * @name TestsuiteApiGetOperationLlmJobsFormattedRetrieve
     * @request GET:/testsuite/api/get-operation-llm-jobs/{operation_id}{format}
     * @secure
     */
    testsuiteApiGetOperationLlmJobsFormattedRetrieve: (
      format: ".json",
      operationId: string,
      params: RequestParams = {},
    ) =>
      this.request<LLMJob[], any>({
        path: `/testsuite/api/get-operation-llm-jobs/${operationId}${format}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags testsuite
     * @name TestsuiteApiGetOperationRetrieve
     * @request GET:/testsuite/api/get-operation/{operation_id}/
     * @secure
     */
    testsuiteApiGetOperationRetrieve: (operationId: string, params: RequestParams = {}) =>
      this.request<Operation, any>({
        path: `/testsuite/api/get-operation/${operationId}/`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags testsuite
     * @name TestsuiteApiGetOperationFormattedRetrieve
     * @request GET:/testsuite/api/get-operation/{operation_id}{format}
     * @secure
     */
    testsuiteApiGetOperationFormattedRetrieve: (format: ".json", operationId: string, params: RequestParams = {}) =>
      this.request<Operation, any>({
        path: `/testsuite/api/get-operation/${operationId}${format}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags testsuite
     * @name TestsuiteApiGetPromptTemplateRetrieve
     * @request GET:/testsuite/api/get-prompt-template/{prompt_template_id}/
     * @secure
     */
    testsuiteApiGetPromptTemplateRetrieve: (promptTemplateId: string, params: RequestParams = {}) =>
      this.request<PromptTemplate, any>({
        path: `/testsuite/api/get-prompt-template/${promptTemplateId}/`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags testsuite
     * @name TestsuiteApiGetPromptTemplateFormattedRetrieve
     * @request GET:/testsuite/api/get-prompt-template/{prompt_template_id}{format}
     * @secure
     */
    testsuiteApiGetPromptTemplateFormattedRetrieve: (
      format: ".json",
      promptTemplateId: string,
      params: RequestParams = {},
    ) =>
      this.request<PromptTemplate, any>({
        path: `/testsuite/api/get-prompt-template/${promptTemplateId}${format}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags testsuite
     * @name TestsuiteApiGetSearchCollectionRetrieve
     * @request GET:/testsuite/api/get-search-collection/{search_collection_id}/
     * @secure
     */
    testsuiteApiGetSearchCollectionRetrieve: (searchCollectionId: string, params: RequestParams = {}) =>
      this.request<SearchCollection, any>({
        path: `/testsuite/api/get-search-collection/${searchCollectionId}/`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags testsuite
     * @name TestsuiteApiGetSearchCollectionFormattedRetrieve
     * @request GET:/testsuite/api/get-search-collection/{search_collection_id}{format}
     * @secure
     */
    testsuiteApiGetSearchCollectionFormattedRetrieve: (
      format: ".json",
      searchCollectionId: string,
      params: RequestParams = {},
    ) =>
      this.request<SearchCollection, any>({
        path: `/testsuite/api/get-search-collection/${searchCollectionId}${format}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags testsuite
     * @name TestsuiteApiGetStudyBlockRetrieve
     * @request GET:/testsuite/api/get-study-block/{study_block_id}/
     * @secure
     */
    testsuiteApiGetStudyBlockRetrieve: (studyBlockId: string, params: RequestParams = {}) =>
      this.request<FullStudyBlock, any>({
        path: `/testsuite/api/get-study-block/${studyBlockId}/`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags testsuite
     * @name TestsuiteApiGetStudyBlockFormattedRetrieve
     * @request GET:/testsuite/api/get-study-block/{study_block_id}{format}
     * @secure
     */
    testsuiteApiGetStudyBlockFormattedRetrieve: (format: ".json", studyBlockId: string, params: RequestParams = {}) =>
      this.request<FullStudyBlock, any>({
        path: `/testsuite/api/get-study-block/${studyBlockId}${format}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags testsuite
     * @name TestsuiteApiGetStudyRetrieve
     * @request GET:/testsuite/api/get-study/{study_id}/
     * @secure
     */
    testsuiteApiGetStudyRetrieve: (studyId: string, params: RequestParams = {}) =>
      this.request<FullStudy, any>({
        path: `/testsuite/api/get-study/${studyId}/`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags testsuite
     * @name TestsuiteApiGetStudyFormattedRetrieve
     * @request GET:/testsuite/api/get-study/{study_id}{format}
     * @secure
     */
    testsuiteApiGetStudyFormattedRetrieve: (format: ".json", studyId: string, params: RequestParams = {}) =>
      this.request<FullStudy, any>({
        path: `/testsuite/api/get-study/${studyId}${format}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags testsuite
     * @name TestsuiteApiGetUserDatasetsRetrieve
     * @request GET:/testsuite/api/get-user-datasets/
     * @secure
     */
    testsuiteApiGetUserDatasetsRetrieve: (params: RequestParams = {}) =>
      this.request<Dataset[], any>({
        path: `/testsuite/api/get-user-datasets/`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags testsuite
     * @name TestsuiteApiGetUserDatasetsFormattedRetrieve
     * @request GET:/testsuite/api/get-user-datasets{format}
     * @secure
     */
    testsuiteApiGetUserDatasetsFormattedRetrieve: (format: ".json", params: RequestParams = {}) =>
      this.request<Dataset[], any>({
        path: `/testsuite/api/get-user-datasets${format}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags testsuite
     * @name TestsuiteApiGetUserExperimentsRetrieve
     * @request GET:/testsuite/api/get-user-experiments/
     * @secure
     */
    testsuiteApiGetUserExperimentsRetrieve: (params: RequestParams = {}) =>
      this.request<ExperimentOverview[], any>({
        path: `/testsuite/api/get-user-experiments/`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags testsuite
     * @name TestsuiteApiGetUserExperimentsFormattedRetrieve
     * @request GET:/testsuite/api/get-user-experiments{format}
     * @secure
     */
    testsuiteApiGetUserExperimentsFormattedRetrieve: (format: ".json", params: RequestParams = {}) =>
      this.request<ExperimentOverview[], any>({
        path: `/testsuite/api/get-user-experiments${format}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags testsuite
     * @name TestsuiteApiGetUserFullExperimentsRetrieve
     * @request GET:/testsuite/api/get-user-full-experiments/
     * @secure
     */
    testsuiteApiGetUserFullExperimentsRetrieve: (params: RequestParams = {}) =>
      this.request<FullExperiment[], any>({
        path: `/testsuite/api/get-user-full-experiments/`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags testsuite
     * @name TestsuiteApiGetUserFullExperimentsFormattedRetrieve
     * @request GET:/testsuite/api/get-user-full-experiments{format}
     * @secure
     */
    testsuiteApiGetUserFullExperimentsFormattedRetrieve: (format: ".json", params: RequestParams = {}) =>
      this.request<FullExperiment[], any>({
        path: `/testsuite/api/get-user-full-experiments${format}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags testsuite
     * @name TestsuiteApiGetUserOperationsRetrieve
     * @request GET:/testsuite/api/get-user-operations/
     * @secure
     */
    testsuiteApiGetUserOperationsRetrieve: (params: RequestParams = {}) =>
      this.request<Operation, any>({
        path: `/testsuite/api/get-user-operations/`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags testsuite
     * @name TestsuiteApiGetUserOperationsFormattedRetrieve
     * @request GET:/testsuite/api/get-user-operations{format}
     * @secure
     */
    testsuiteApiGetUserOperationsFormattedRetrieve: (format: ".json", params: RequestParams = {}) =>
      this.request<Operation, any>({
        path: `/testsuite/api/get-user-operations${format}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags testsuite
     * @name TestsuiteApiGetUserPromptTemplatesRetrieve
     * @request GET:/testsuite/api/get-user-prompt-templates/
     * @secure
     */
    testsuiteApiGetUserPromptTemplatesRetrieve: (params: RequestParams = {}) =>
      this.request<PromptTemplate[], any>({
        path: `/testsuite/api/get-user-prompt-templates/`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags testsuite
     * @name TestsuiteApiGetUserPromptTemplatesFormattedRetrieve
     * @request GET:/testsuite/api/get-user-prompt-templates{format}
     * @secure
     */
    testsuiteApiGetUserPromptTemplatesFormattedRetrieve: (format: ".json", params: RequestParams = {}) =>
      this.request<PromptTemplate[], any>({
        path: `/testsuite/api/get-user-prompt-templates${format}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags testsuite
     * @name TestsuiteApiGetUserStudiesRetrieve
     * @request GET:/testsuite/api/get-user-studies/
     * @secure
     */
    testsuiteApiGetUserStudiesRetrieve: (params: RequestParams = {}) =>
      this.request<FullStudy[], any>({
        path: `/testsuite/api/get-user-studies/`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags testsuite
     * @name TestsuiteApiGetUserStudiesFormattedRetrieve
     * @request GET:/testsuite/api/get-user-studies{format}
     * @secure
     */
    testsuiteApiGetUserStudiesFormattedRetrieve: (format: ".json", params: RequestParams = {}) =>
      this.request<FullStudy[], any>({
        path: `/testsuite/api/get-user-studies${format}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags testsuite
     * @name TestsuiteApiIndexWithWeaviateCreate
     * @request POST:/testsuite/api/index-with-weaviate/
     * @secure
     */
    testsuiteApiIndexWithWeaviateCreate: (
      data: {
        dataset_id: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<string, any>({
        path: `/testsuite/api/index-with-weaviate/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags testsuite
     * @name TestsuiteApiIndexWithWeaviateFormattedCreate
     * @request POST:/testsuite/api/index-with-weaviate{format}
     * @secure
     */
    testsuiteApiIndexWithWeaviateFormattedCreate: (
      format: ".json",
      data: {
        dataset_id: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<string, any>({
        path: `/testsuite/api/index-with-weaviate${format}`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags testsuite
     * @name TestsuiteApiNextOperationCreate
     * @request POST:/testsuite/api/next-operation/{operation_id}/
     * @secure
     */
    testsuiteApiNextOperationCreate: (operationId: string, data: object, params: RequestParams = {}) =>
      this.request<FullOperation, any>({
        path: `/testsuite/api/next-operation/${operationId}/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags testsuite
     * @name TestsuiteApiNextOperationFormattedCreate
     * @request POST:/testsuite/api/next-operation/{operation_id}{format}
     * @secure
     */
    testsuiteApiNextOperationFormattedCreate: (
      format: ".json",
      operationId: string,
      data: object,
      params: RequestParams = {},
    ) =>
      this.request<FullOperation, any>({
        path: `/testsuite/api/next-operation/${operationId}${format}`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags testsuite
     * @name TestsuiteApiPreviewPromptTemplateCreate
     * @request POST:/testsuite/api/preview-prompt-template/
     * @secure
     */
    testsuiteApiPreviewPromptTemplateCreate: (
      data: {
        prompt: string;
        dataset_id: number;
        type: string;
        output_type: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<string, any>({
        path: `/testsuite/api/preview-prompt-template/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags testsuite
     * @name TestsuiteApiPreviewPromptTemplateFormattedCreate
     * @request POST:/testsuite/api/preview-prompt-template{format}
     * @secure
     */
    testsuiteApiPreviewPromptTemplateFormattedCreate: (
      format: ".json",
      data: {
        prompt: string;
        dataset_id: number;
        type: string;
        output_type: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<string, any>({
        path: `/testsuite/api/preview-prompt-template${format}`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags testsuite
     * @name TestsuiteApiRedownloadAllLlmJobsCreate
     * @request POST:/testsuite/api/redownload-all-llm-jobs/
     * @secure
     */
    testsuiteApiRedownloadAllLlmJobsCreate: (params: RequestParams = {}) =>
      this.request<LLMJob[], any>({
        path: `/testsuite/api/redownload-all-llm-jobs/`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags testsuite
     * @name TestsuiteApiRedownloadAllLlmJobsFormattedCreate
     * @request POST:/testsuite/api/redownload-all-llm-jobs{format}
     * @secure
     */
    testsuiteApiRedownloadAllLlmJobsFormattedCreate: (format: ".json", params: RequestParams = {}) =>
      this.request<LLMJob[], any>({
        path: `/testsuite/api/redownload-all-llm-jobs${format}`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags testsuite
     * @name TestsuiteApiRedownloadLlmJobCreate
     * @request POST:/testsuite/api/redownload-llm-job/
     * @secure
     */
    testsuiteApiRedownloadLlmJobCreate: (data: RedownloadBatchLLMJob, params: RequestParams = {}) =>
      this.request<LLMJob, any>({
        path: `/testsuite/api/redownload-llm-job/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags testsuite
     * @name TestsuiteApiRedownloadLlmJobFormattedCreate
     * @request POST:/testsuite/api/redownload-llm-job{format}
     * @secure
     */
    testsuiteApiRedownloadLlmJobFormattedCreate: (
      format: ".json",
      data: RedownloadBatchLLMJob,
      params: RequestParams = {},
    ) =>
      this.request<LLMJob, any>({
        path: `/testsuite/api/redownload-llm-job${format}`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags testsuite
     * @name TestsuiteApiRetryLlmJobCreate
     * @request POST:/testsuite/api/retry-llm-job/
     * @secure
     */
    testsuiteApiRetryLlmJobCreate: (data: RetryLLMJob, params: RequestParams = {}) =>
      this.request<LLMJob, any>({
        path: `/testsuite/api/retry-llm-job/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags testsuite
     * @name TestsuiteApiRetryLlmJobFormattedCreate
     * @request POST:/testsuite/api/retry-llm-job{format}
     * @secure
     */
    testsuiteApiRetryLlmJobFormattedCreate: (format: ".json", data: RetryLLMJob, params: RequestParams = {}) =>
      this.request<LLMJob, any>({
        path: `/testsuite/api/retry-llm-job${format}`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags testsuite
     * @name TestsuiteApiRunAnalysisCreate
     * @request POST:/testsuite/api/run-analysis/{analysis_id}/
     * @secure
     */
    testsuiteApiRunAnalysisCreate: (analysisId: string, data: object, params: RequestParams = {}) =>
      this.request<FullAnalysis, any>({
        path: `/testsuite/api/run-analysis/${analysisId}/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags testsuite
     * @name TestsuiteApiRunAnalysisFormattedCreate
     * @request POST:/testsuite/api/run-analysis/{analysis_id}{format}
     * @secure
     */
    testsuiteApiRunAnalysisFormattedCreate: (
      analysisId: string,
      format: ".json",
      data: object,
      params: RequestParams = {},
    ) =>
      this.request<FullAnalysis, any>({
        path: `/testsuite/api/run-analysis/${analysisId}${format}`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags testsuite
     * @name TestsuiteApiRunFullExperimentCreate
     * @request POST:/testsuite/api/run-full-experiment/{experiment_id}/
     * @secure
     */
    testsuiteApiRunFullExperimentCreate: (
      experimentId: string,
      data: {
        params?: object;
      },
      params: RequestParams = {},
    ) =>
      this.request<FullExperiment, any>({
        path: `/testsuite/api/run-full-experiment/${experimentId}/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags testsuite
     * @name TestsuiteApiRunFullExperimentFormattedCreate
     * @request POST:/testsuite/api/run-full-experiment/{experiment_id}{format}
     * @secure
     */
    testsuiteApiRunFullExperimentFormattedCreate: (
      experimentId: string,
      format: ".json",
      data: {
        params?: object;
      },
      params: RequestParams = {},
    ) =>
      this.request<FullExperiment, any>({
        path: `/testsuite/api/run-full-experiment/${experimentId}${format}`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags testsuite
     * @name TestsuiteApiRunOperationCreate
     * @request POST:/testsuite/api/run-operation/{operation_id}/
     * @secure
     */
    testsuiteApiRunOperationCreate: (operationId: string, data: FullOperation, params: RequestParams = {}) =>
      this.request<FullOperation, any>({
        path: `/testsuite/api/run-operation/${operationId}/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags testsuite
     * @name TestsuiteApiRunOperationFormattedCreate
     * @request POST:/testsuite/api/run-operation/{operation_id}{format}
     * @secure
     */
    testsuiteApiRunOperationFormattedCreate: (
      format: ".json",
      operationId: string,
      data: FullOperation,
      params: RequestParams = {},
    ) =>
      this.request<FullOperation, any>({
        path: `/testsuite/api/run-operation/${operationId}${format}`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags testsuite
     * @name TestsuiteApiRunPythonSandboxForDatasetCreate
     * @request POST:/testsuite/api/run-python-sandbox-for-dataset/
     * @secure
     */
    testsuiteApiRunPythonSandboxForDatasetCreate: (data: PythonSandboxForDatasets, params: RequestParams = {}) =>
      this.request<Record<string, any>, any>({
        path: `/testsuite/api/run-python-sandbox-for-dataset/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags testsuite
     * @name TestsuiteApiRunPythonSandboxForDatasetFormattedCreate
     * @request POST:/testsuite/api/run-python-sandbox-for-dataset{format}
     * @secure
     */
    testsuiteApiRunPythonSandboxForDatasetFormattedCreate: (
      format: ".json",
      data: PythonSandboxForDatasets,
      params: RequestParams = {},
    ) =>
      this.request<Record<string, any>, any>({
        path: `/testsuite/api/run-python-sandbox-for-dataset${format}`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags testsuite
     * @name TestsuiteApiSearchCreate
     * @request POST:/testsuite/api/search/
     * @secure
     */
    testsuiteApiSearchCreate: (data: Search, params: RequestParams = {}) =>
      this.request<SearchResult, any>({
        path: `/testsuite/api/search/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags testsuite
     * @name TestsuiteApiSearchFormattedCreate
     * @request POST:/testsuite/api/search{format}
     * @secure
     */
    testsuiteApiSearchFormattedCreate: (format: ".json", data: Search, params: RequestParams = {}) =>
      this.request<SearchResult, any>({
        path: `/testsuite/api/search${format}`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags testsuite
     * @name TestsuiteApiSemanticSearchCreate
     * @request POST:/testsuite/api/semantic-search/
     * @secure
     */
    testsuiteApiSemanticSearchCreate: (
      data: {
        query: string;
        limit?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<Datum[], any>({
        path: `/testsuite/api/semantic-search/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags testsuite
     * @name TestsuiteApiSemanticSearchFormattedCreate
     * @request POST:/testsuite/api/semantic-search{format}
     * @secure
     */
    testsuiteApiSemanticSearchFormattedCreate: (
      format: ".json",
      data: {
        query: string;
        limit?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<Datum[], any>({
        path: `/testsuite/api/semantic-search${format}`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags testsuite
     * @name TestsuiteApiTestRenderPromptCreate
     * @request POST:/testsuite/api/test-render-prompt/
     * @secure
     */
    testsuiteApiTestRenderPromptCreate: (
      data: {
        prompt: string;
        datum: object;
        type: "SYSTEM" | "USER";
        output_type: "TEXT" | "JSON";
      },
      params: RequestParams = {},
    ) =>
      this.request<string, any>({
        path: `/testsuite/api/test-render-prompt/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags testsuite
     * @name TestsuiteApiTestRenderPromptFormattedCreate
     * @request POST:/testsuite/api/test-render-prompt{format}
     * @secure
     */
    testsuiteApiTestRenderPromptFormattedCreate: (
      format: ".json",
      data: {
        prompt: string;
        datum: object;
        type: "SYSTEM" | "USER";
        output_type: "TEXT" | "JSON";
      },
      params: RequestParams = {},
    ) =>
      this.request<string, any>({
        path: `/testsuite/api/test-render-prompt${format}`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags testsuite
     * @name TestsuiteApiTestsuiteCreateVectorOntologyCreate
     * @request POST:/testsuite/api/testsuite/create-vector-ontology/
     * @secure
     */
    testsuiteApiTestsuiteCreateVectorOntologyCreate: (data: CreateVectorOntologyRequest, params: RequestParams = {}) =>
      this.request<OntologyLeaderboardEntry, ErrorResponse>({
        path: `/testsuite/api/testsuite/create-vector-ontology/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags testsuite
     * @name TestsuiteApiTestsuiteCreateVectorOntologyFormattedCreate
     * @request POST:/testsuite/api/testsuite/create-vector-ontology{format}
     * @secure
     */
    testsuiteApiTestsuiteCreateVectorOntologyFormattedCreate: (
      format: ".json",
      data: CreateVectorOntologyRequest,
      params: RequestParams = {},
    ) =>
      this.request<OntologyLeaderboardEntry, ErrorResponse>({
        path: `/testsuite/api/testsuite/create-vector-ontology${format}`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags testsuite
     * @name TestsuiteApiTestsuiteGetDimensionLeaderboardCreate
     * @request POST:/testsuite/api/testsuite/get-dimension-leaderboard/
     * @secure
     */
    testsuiteApiTestsuiteGetDimensionLeaderboardCreate: (
      data: GetDimensionLeaderboardRequest,
      params: RequestParams = {},
    ) =>
      this.request<DimensionLeaderboardEntry[], any>({
        path: `/testsuite/api/testsuite/get-dimension-leaderboard/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags testsuite
     * @name TestsuiteApiTestsuiteGetDimensionLeaderboardFormattedCreate
     * @request POST:/testsuite/api/testsuite/get-dimension-leaderboard{format}
     * @secure
     */
    testsuiteApiTestsuiteGetDimensionLeaderboardFormattedCreate: (
      format: ".json",
      data: GetDimensionLeaderboardRequest,
      params: RequestParams = {},
    ) =>
      this.request<DimensionLeaderboardEntry[], any>({
        path: `/testsuite/api/testsuite/get-dimension-leaderboard${format}`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags testsuite
     * @name TestsuiteApiTestsuiteGetOntologyLeaderboardCreate
     * @request POST:/testsuite/api/testsuite/get-ontology-leaderboard/
     * @secure
     */
    testsuiteApiTestsuiteGetOntologyLeaderboardCreate: (data: GetLeaderboardRequest, params: RequestParams = {}) =>
      this.request<OntologyLeaderboardEntry[], any>({
        path: `/testsuite/api/testsuite/get-ontology-leaderboard/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags testsuite
     * @name TestsuiteApiTestsuiteGetOntologyLeaderboardFormattedCreate
     * @request POST:/testsuite/api/testsuite/get-ontology-leaderboard{format}
     * @secure
     */
    testsuiteApiTestsuiteGetOntologyLeaderboardFormattedCreate: (
      format: ".json",
      data: GetLeaderboardRequest,
      params: RequestParams = {},
    ) =>
      this.request<OntologyLeaderboardEntry[], any>({
        path: `/testsuite/api/testsuite/get-ontology-leaderboard${format}`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags testsuite
     * @name TestsuiteApiTestsuiteGetVectorOntologyRetrieve
     * @request GET:/testsuite/api/testsuite/get-vector-ontology/{vector_ontology_id}/
     * @secure
     */
    testsuiteApiTestsuiteGetVectorOntologyRetrieve: (vectorOntologyId: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/testsuite/api/testsuite/get-vector-ontology/${vectorOntologyId}/`,
        method: "GET",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags testsuite
     * @name TestsuiteApiTestsuiteGetVectorOntologyFormattedRetrieve
     * @request GET:/testsuite/api/testsuite/get-vector-ontology/{vector_ontology_id}{format}
     * @secure
     */
    testsuiteApiTestsuiteGetVectorOntologyFormattedRetrieve: (
      format: ".json",
      vectorOntologyId: string,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/testsuite/api/testsuite/get-vector-ontology/${vectorOntologyId}${format}`,
        method: "GET",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags testsuite
     * @name TestsuiteApiTestsuiteRunBenchmarkDatasetCreate
     * @request POST:/testsuite/api/testsuite/run-benchmark-dataset/
     * @secure
     */
    testsuiteApiTestsuiteRunBenchmarkDatasetCreate: (data: BenchmarkDatasetArgs, params: RequestParams = {}) =>
      this.request<BenchmarkDataset, any>({
        path: `/testsuite/api/testsuite/run-benchmark-dataset/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags testsuite
     * @name TestsuiteApiTestsuiteRunBenchmarkDatasetFormattedCreate
     * @request POST:/testsuite/api/testsuite/run-benchmark-dataset{format}
     * @secure
     */
    testsuiteApiTestsuiteRunBenchmarkDatasetFormattedCreate: (
      format: ".json",
      data: BenchmarkDatasetArgs,
      params: RequestParams = {},
    ) =>
      this.request<BenchmarkDataset, any>({
        path: `/testsuite/api/testsuite/run-benchmark-dataset${format}`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags testsuite
     * @name TestsuiteApiTestsuiteUpdateSearchUpdate
     * @request PUT:/testsuite/api/testsuite/update-search/{search_result_id}/
     * @secure
     */
    testsuiteApiTestsuiteUpdateSearchUpdate: (
      searchResultId: number,
      data: {
        correct_datum: number | null;
      },
      params: RequestParams = {},
    ) =>
      this.request<SearchResult, any>({
        path: `/testsuite/api/testsuite/update-search/${searchResultId}/`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags testsuite
     * @name TestsuiteApiTestsuiteUpdateSearchFormattedUpdate
     * @request PUT:/testsuite/api/testsuite/update-search/{search_result_id}{format}
     * @secure
     */
    testsuiteApiTestsuiteUpdateSearchFormattedUpdate: (
      format: ".json",
      searchResultId: number,
      data: {
        correct_datum: number | null;
      },
      params: RequestParams = {},
    ) =>
      this.request<SearchResult, any>({
        path: `/testsuite/api/testsuite/update-search/${searchResultId}${format}`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags testsuite
     * @name TestsuiteApiTryToRepairExperimentCreate
     * @request POST:/testsuite/api/try-to-repair-experiment/{experiment_id}/
     * @secure
     */
    testsuiteApiTryToRepairExperimentCreate: (
      experimentId: string,
      data: {
        params?: object;
      },
      params: RequestParams = {},
    ) =>
      this.request<FullExperiment, any>({
        path: `/testsuite/api/try-to-repair-experiment/${experimentId}/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags testsuite
     * @name TestsuiteApiTryToRepairExperimentFormattedCreate
     * @request POST:/testsuite/api/try-to-repair-experiment/{experiment_id}{format}
     * @secure
     */
    testsuiteApiTryToRepairExperimentFormattedCreate: (
      experimentId: string,
      format: ".json",
      data: {
        params?: object;
      },
      params: RequestParams = {},
    ) =>
      this.request<FullExperiment, any>({
        path: `/testsuite/api/try-to-repair-experiment/${experimentId}${format}`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags testsuite
     * @name TestsuiteApiTryToRepairOperationCreate
     * @request POST:/testsuite/api/try-to-repair-operation/{operation_id}/
     * @secure
     */
    testsuiteApiTryToRepairOperationCreate: (operationId: string, data: FullOperation, params: RequestParams = {}) =>
      this.request<FullOperation, any>({
        path: `/testsuite/api/try-to-repair-operation/${operationId}/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags testsuite
     * @name TestsuiteApiTryToRepairOperationFormattedCreate
     * @request POST:/testsuite/api/try-to-repair-operation/{operation_id}{format}
     * @secure
     */
    testsuiteApiTryToRepairOperationFormattedCreate: (
      format: ".json",
      operationId: string,
      data: FullOperation,
      params: RequestParams = {},
    ) =>
      this.request<FullOperation, any>({
        path: `/testsuite/api/try-to-repair-operation/${operationId}${format}`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags testsuite
     * @name TestsuiteApiUpdateAnalysisUpdate
     * @request PUT:/testsuite/api/update-analysis/{analysis_id}/
     * @secure
     */
    testsuiteApiUpdateAnalysisUpdate: (
      analysisId: string,
      data: {
        name?: string;
        description?: string;
        params?: object;
        input_datasets?: any[];
      },
      params: RequestParams = {},
    ) =>
      this.request<FullAnalysis, any>({
        path: `/testsuite/api/update-analysis/${analysisId}/`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.FormData,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags testsuite
     * @name TestsuiteApiUpdateAnalysisFormattedUpdate
     * @request PUT:/testsuite/api/update-analysis/{analysis_id}{format}
     * @secure
     */
    testsuiteApiUpdateAnalysisFormattedUpdate: (
      analysisId: string,
      format: ".json",
      data: {
        name?: string;
        description?: string;
        params?: object;
        input_datasets?: any[];
      },
      params: RequestParams = {},
    ) =>
      this.request<FullAnalysis, any>({
        path: `/testsuite/api/update-analysis/${analysisId}${format}`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.FormData,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags testsuite
     * @name TestsuiteApiUpdateDatasetInfoUpdate
     * @request PUT:/testsuite/api/update-dataset-info/{dataset_id}/
     * @secure
     */
    testsuiteApiUpdateDatasetInfoUpdate: (datasetId: string, data: DatasetUpdate, params: RequestParams = {}) =>
      this.request<DatasetUpdate, any>({
        path: `/testsuite/api/update-dataset-info/${datasetId}/`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags testsuite
     * @name TestsuiteApiUpdateDatasetInfoFormattedUpdate
     * @request PUT:/testsuite/api/update-dataset-info/{dataset_id}{format}
     * @secure
     */
    testsuiteApiUpdateDatasetInfoFormattedUpdate: (
      datasetId: string,
      format: ".json",
      data: DatasetUpdate,
      params: RequestParams = {},
    ) =>
      this.request<DatasetUpdate, any>({
        path: `/testsuite/api/update-dataset-info/${datasetId}${format}`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Update an existing experiment with the provided details.
     *
     * @tags testsuite
     * @name TestsuiteApiUpdateExperimentUpdate
     * @request PUT:/testsuite/api/update-experiment/{experiment_id}/
     * @secure
     */
    testsuiteApiUpdateExperimentUpdate: (
      experimentId: string,
      data: {
        name: string;
        description: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<FullExperiment, any>({
        path: `/testsuite/api/update-experiment/${experimentId}/`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.FormData,
        format: "json",
        ...params,
      }),

    /**
     * @description Update an existing experiment with the provided details.
     *
     * @tags testsuite
     * @name TestsuiteApiUpdateExperimentFormattedUpdate
     * @request PUT:/testsuite/api/update-experiment/{experiment_id}{format}
     * @secure
     */
    testsuiteApiUpdateExperimentFormattedUpdate: (
      experimentId: string,
      format: ".json",
      data: {
        name: string;
        description: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<FullExperiment, any>({
        path: `/testsuite/api/update-experiment/${experimentId}${format}`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.FormData,
        format: "json",
        ...params,
      }),

    /**
     * @description Update an existing operation with the provided details.
     *
     * @tags testsuite
     * @name TestsuiteApiUpdateOperationUpdate
     * @request PUT:/testsuite/api/update-operation/{operation_id}/
     * @secure
     */
    testsuiteApiUpdateOperationUpdate: (operationId: string, data: Operation, params: RequestParams = {}) =>
      this.request<FullOperation, void>({
        path: `/testsuite/api/update-operation/${operationId}/`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Update an existing operation with the provided details.
     *
     * @tags testsuite
     * @name TestsuiteApiUpdateOperationFormattedUpdate
     * @request PUT:/testsuite/api/update-operation/{operation_id}{format}
     * @secure
     */
    testsuiteApiUpdateOperationFormattedUpdate: (
      format: ".json",
      operationId: string,
      data: Operation,
      params: RequestParams = {},
    ) =>
      this.request<FullOperation, void>({
        path: `/testsuite/api/update-operation/${operationId}${format}`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Update an existing prompt template with the provided details.
     *
     * @tags testsuite
     * @name TestsuiteApiUpdatePromptTemplateUpdate
     * @request PUT:/testsuite/api/update-prompt-template/{prompt_template_id}/
     * @secure
     */
    testsuiteApiUpdatePromptTemplateUpdate: (
      promptTemplateId: string,
      data: PromptTemplate,
      params: RequestParams = {},
    ) =>
      this.request<FullPromptTemplate, void>({
        path: `/testsuite/api/update-prompt-template/${promptTemplateId}/`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Update an existing prompt template with the provided details.
     *
     * @tags testsuite
     * @name TestsuiteApiUpdatePromptTemplateFormattedUpdate
     * @request PUT:/testsuite/api/update-prompt-template/{prompt_template_id}{format}
     * @secure
     */
    testsuiteApiUpdatePromptTemplateFormattedUpdate: (
      format: ".json",
      promptTemplateId: string,
      data: PromptTemplate,
      params: RequestParams = {},
    ) =>
      this.request<FullPromptTemplate, void>({
        path: `/testsuite/api/update-prompt-template/${promptTemplateId}${format}`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags testsuite
     * @name TestsuiteApiUpdateStudyBlockUpdate
     * @request PUT:/testsuite/api/update-study-block/{study_block_id}/
     * @secure
     */
    testsuiteApiUpdateStudyBlockUpdate: (
      studyBlockId: string,
      data: {
        order?: number;
        content?: string;
        analysis?: number;
        experiment?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<FullStudyBlock, any>({
        path: `/testsuite/api/update-study-block/${studyBlockId}/`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.FormData,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags testsuite
     * @name TestsuiteApiUpdateStudyBlockFormattedUpdate
     * @request PUT:/testsuite/api/update-study-block/{study_block_id}{format}
     * @secure
     */
    testsuiteApiUpdateStudyBlockFormattedUpdate: (
      format: ".json",
      studyBlockId: string,
      data: {
        order?: number;
        content?: string;
        analysis?: number;
        experiment?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<FullStudyBlock, any>({
        path: `/testsuite/api/update-study-block/${studyBlockId}${format}`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.FormData,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags testsuite
     * @name TestsuiteApiUpdateStudyUpdate
     * @request PUT:/testsuite/api/update-study/{study_id}/
     * @secure
     */
    testsuiteApiUpdateStudyUpdate: (
      studyId: string,
      data: {
        name: string;
        description: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<FullStudy, any>({
        path: `/testsuite/api/update-study/${studyId}/`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.FormData,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags testsuite
     * @name TestsuiteApiUpdateStudyFormattedUpdate
     * @request PUT:/testsuite/api/update-study/{study_id}{format}
     * @secure
     */
    testsuiteApiUpdateStudyFormattedUpdate: (
      format: ".json",
      studyId: string,
      data: {
        name: string;
        description: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<FullStudy, any>({
        path: `/testsuite/api/update-study/${studyId}${format}`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.FormData,
        format: "json",
        ...params,
      }),
  };
  user = {
    /**
     * No description
     *
     * @tags user
     * @name UserRetrieve
     * @request GET:/user
     * @secure
     */
    userRetrieve: (params: RequestParams = {}) =>
      this.request<UserResponse, any>({
        path: `/user`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),
  };
  verifyToken = {
    /**
     * No description
     *
     * @tags verify_token
     * @name VerifyTokenCreate
     * @request POST:/verify_token/
     * @secure
     */
    verifyTokenCreate: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/verify_token/`,
        method: "POST",
        secure: true,
        ...params,
      }),
  };
}
